// Contactos.jsx
import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import * as XLSX from 'xlsx';
import { FaAddressBook, FaEdit, FaFileImport, FaListUl, FaPlus, FaSearch, FaTrash, FaUserPlus } from "react-icons/fa";
import { Sidebar, formats } from "../components/Note";
import api, { API_BASE } from "../api";
import "../styles/NoteDashboard.css";

function Contactos() {
  const ENABLE_LIST_SAVE_HOTKEY = false;
  const NO_LIST_FILTER_ID = "__no_list__";
  const [contacts, setContacts] = useState([]);
  const [tags, setTags] = useState([]);
  const [activeTagId, setActiveTagId] = useState("");
  const [showTagModal, setShowTagModal] = useState(false);
  const [tagForm, setTagForm] = useState({ id: null, name: "", color: "#60a5fa" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // ESTADOS FALTANTES (restaurados tras corrupción del archivo)
  const [q, setQ] = useState("");
  const [listDetailQ, setListDetailQ] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [showActions, setShowActions] = useState(false);
  const [isBatching, setIsBatching] = useState(false);
  const pageSize = 20;
  const [pageTop, setPageTop] = useState(1);
  const [pageBottom, setPageBottom] = useState(1);
  const [activeListId, setActiveListId] = useState(null);
  const [activeList, setActiveList] = useState(null);
  const [lists, setLists] = useState([]);
  const [listForm, setListForm] = useState({ mode: "new", name: "", listId: null, color: "#60a5fa" });
  const [listModalMove, setListModalMove] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [listEditForm, setListEditForm] = useState({ name: "", color: "#60a5fa" });
  const [showListEditModal, setShowListEditModal] = useState(false);
  const [editingListId, setEditingListId] = useState(null);
  const [isListBusy, setIsListBusy] = useState(false);
  const [listEditError, setListEditError] = useState("");
  const [isTagBusy, setIsTagBusy] = useState(false);
  const [tagError, setTagError] = useState("");
  const [showListCreateModal, setShowListCreateModal] = useState(false);
  const [listCreateForm, setListCreateForm] = useState({ name: "", description: "", color: "#22c55e" });
  const [listCreateError, setListCreateError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ full_name: "", phone: "", note: "" });
  const [formError, setFormError] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editForm, setEditForm] = useState({ id: null, first_name: "", last_name: "", phone: "", countryCode: "+593" });
  const [editError, setEditError] = useState({});
  const [isEditSaving, setIsEditSaving] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [importState, setImportState] = useState({ file: null, creatingList: false, listName: "", listColor: "#60a5fa", countryCode: "+593" });
  const [importBusy, setImportBusy] = useState(false);
  const [importError, setImportError] = useState("");
  const [noteDrafts, setNoteDrafts] = useState({});
  const [openNoteIds, setOpenNoteIds] = useState(new Set());
  const [savingNoteIds, setSavingNoteIds] = useState(new Set());
  const [noteFilter, setNoteFilter] = useState("");
  const [tagActionMode, setTagActionMode] = useState(null); // 'save' | 'move'
  const [tagActionTagId, setTagActionTagId] = useState(null);
  const [activeListFilterId, setActiveListFilterId] = useState(null);
  const [activeDuplicateFilter, setActiveDuplicateFilter] = useState(false);
  const actionsRef = useRef(null);
  const actionsHoverCloseRef = useRef(null);
  // Modal: ver miembros de una lista al hacer click en el badge de la lista
  const [showListMembers, setShowListMembers] = useState(false);
  const [listMembersListId, setListMembersListId] = useState(null);
  const [listMembersQ, setListMembersQ] = useState("");
  const [showAddContactsModal, setShowAddContactsModal] = useState(false);
  const [addContactsQ, setAddContactsQ] = useState("");
  const [addContactsSelectedIds, setAddContactsSelectedIds] = useState(new Set());
  const [isAddContactsBusy, setIsAddContactsBusy] = useState(false);
  const [addContactsError, setAddContactsError] = useState("");
  const [listSelectionMode, setListSelectionMode] = useState(false);
  const [listSelectedIds, setListSelectedIds] = useState(new Set());
  const [listSelectionBusy, setListSelectionBusy] = useState(false);
  const listLongPressTimerRef = useRef(null);
  const listLongPressTriggeredRef = useRef(false);

  // Tema (misma lógica Plantillas)
  const [dark, setDark] = useState(localStorage.getItem("theme") === "dark");
  const [contactsViewTab, setContactsViewTab] = useState("contacts");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  // Diagnóstico: log de apertura de modales clave
  useEffect(() => { try { console.log('[Contactos] showForm =', showForm); } catch {} }, [showForm]);
  useEffect(() => { try { console.log('[Contactos] showImport =', showImport); } catch {} }, [showImport]);

  // Diagnóstico: trazas cuando se intentan abrir modales de listas
  useEffect(() => {
    try { console.log('[Contactos] showListEditModal', showListEditModal, { editingListId, activeListId }); } catch {}
  }, [showListEditModal]);
  useEffect(() => {
    try { console.log('[Contactos] showListCreateModal', showListCreateModal); } catch {}
  }, [showListCreateModal]);
  useEffect(() => {
    try { console.log('[Contactos] showListModal (guardar/mover)', showListModal, { listModalMove, listForm }); } catch {}
  }, [showListModal]);

  // Atajo de depuración: tecla "L" abre el modal Crear lista
  useEffect(() => {
    const onKey = (e) => {
      // Abrir Crear lista
      if ((e.key === 'lLnmf' || e.key === 'Lnmf') && !showListCreateModal) {
        try { console.log('[Contactos] Hotkey L → abrir Crear lista'); } catch {}
        setListCreateForm({ name: '', description: '', color: '#22c55e' });
        setShowListCreateModal(true);
      }
      // Abrir Guardar/Mover en lista
      if (ENABLE_LIST_SAVE_HOTKEY && (e.key === 'm' || e.key === 'M') && !showListModal) {
        try { console.log('[Contactos] Hotkey M → abrir Guardar/Mover en lista'); } catch {}
        setListForm((f) => ({ ...f, mode: 'new' }));
        setListModalMove(false);
        setShowListModal(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [showListCreateModal]);

  // Cerrar menú Acciones al hacer click fuera
  useEffect(() => {
    const handler = (e) => {
      if (actionsRef.current && !actionsRef.current.contains(e.target)) {
        setShowActions(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const openActionsBubble = () => {
    if (isBatching) return;
    if (actionsHoverCloseRef.current) {
      window.clearTimeout(actionsHoverCloseRef.current);
      actionsHoverCloseRef.current = null;
    }
    setShowActions(true);
  };

  const scheduleCloseActionsBubble = () => {
    if (actionsHoverCloseRef.current) {
      window.clearTimeout(actionsHoverCloseRef.current);
    }
    actionsHoverCloseRef.current = window.setTimeout(() => {
      setShowActions(false);
      actionsHoverCloseRef.current = null;
    }, 120);
  };

  useEffect(() => {
    return () => {
      if (actionsHoverCloseRef.current) {
        window.clearTimeout(actionsHoverCloseRef.current);
      }
    };
  }, []);

  // Países (igual que en tu archivo original)
  const COUNTRY_CODES = [
    { code: "+593", label: "Ecuador" },
    { code: "+57", label: "Colombia" },
    { code: "+51", label: "Perú" },
    { code: "+52", label: "México" },
    { code: "+56", label: "Chile" },
    { code: "+54", label: "Argentina" },
    { code: "+34", label: "España" },
    { code: "+1", label: "EE.UU." },
  ];

  const LIST_COLOR_PRESETS = ["#22c55e", "#60a5fa", "#a78bfa", "#f59e0b", "#ef4444", "#06b6d4", "#f97316"];

  // ================== Componentes auxiliares (TagDropdown, ListDropdown, TagFilterDropdown) ==================
  const TagDropdown = ({ tags, value, onChange, allowNull = false, variant = "light" }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const handler = (e) => {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, []);
    const current = tags.find((t) => String(t.id) === String(value));
    const isDark = variant === "dark";
    const baseBtn = {
      background: isDark ? "#1f2937" : "#f9fafb",
      color: isDark ? "#fff" : "#111827",
      border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}`,
      borderRadius: 8,
      padding: ".35rem .55rem",
      fontSize: 13,
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
    };
    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button type="button" onClick={() => setOpen((o) => !o)} style={baseBtn}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <span style={{ width: 10, height: 10, borderRadius: 9999, background: current?.color || (isDark ? "#334155" : "#e5e7eb"), display: "inline-block", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}` }} />
            <span>{current ? current.name : "Etiqueta"}</span>
          </span>
          <span style={{ opacity: 0.6 }}>▾</span>
        </button>
        {open && (
          <div style={{ position: "absolute", top: "100%", right: 0, marginTop: 6, background: isDark ? "#0f172a" : "#ffffff", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}`, borderRadius: 8, minWidth: 180, zIndex: 90, boxShadow: "0 8px 24px rgba(0,0,0,.25)" }}>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              {allowNull && (
                <div onClick={() => { onChange(null); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: `1px solid ${isDark ? "#162033" : "#f1f5f9"}` }}>
                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: isDark ? "#334155" : "#e5e7eb", display: "inline-block", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}` }} />
                  <span>— Sin etiqueta —</span>
                </div>
              )}
              {tags.map((t) => (
                <div key={t.id} onClick={() => { onChange(t.id); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: `1px solid ${isDark ? "#162033" : "#f1f5f9"}` }}>
                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: t.color || "#9ca3af", display: "inline-block", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}` }} />
                  <span>{t.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const TagFilterDropdown = ({ tags, value, onChange }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const handler = (e) => {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, []);
    const selected = tags.find((t) => String(t.id) === String(value));
    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button type="button" onClick={() => setOpen((o) => !o)} style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: ".45rem .6rem", display: "inline-flex", alignItems: "center", gap: 6 }}>
          <span style={{ width: 10, height: 10, borderRadius: 9999, background: selected?.color || "#e5e7eb", display: "inline-block", border: "1px solid #e5e7eb" }} />
          <span style={{ fontSize: 14 }}>{selected ? selected.name : "Filtrar etiqueta"}</span>
          <span style={{ opacity: 0.6 }}>▾</span>
        </button>
        {open && (
          <div style={{ position: "absolute", top: "100%", left: 0, marginTop: 6, background: "#0f172a", border: "1px solid #2a3547", borderRadius: 8, minWidth: 260, zIndex: 120, boxShadow: "0 8px 24px rgba(0,0,0,.35)" }}>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              <div onClick={() => { onChange(""); setOpen(false); }} style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>Todas</div>
              {tags.map((t) => (
                <div key={t.id} onClick={() => { onChange(String(t.id)); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>
                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: t.color, display: "inline-block", border: "1px solid #2a3547" }} />
                  <span>{t.name}</span>
                </div>
              ))}
            </div>
            {/* Acciones de etiqueta dentro del filtro (similar a listas) */}
            <div
              style={{ padding: 10, borderTop: "1px solid #162033", display: "flex", gap: 8, justifyContent: "flex-end" }}
              onMouseDown={(e) => { e.stopPropagation(); }}
              onClick={(e) => { e.stopPropagation(); }}
            >
              <button
                type="button"
                onClick={() => {
                  if (!selected) return;
                  // Cerrar dropdown y abrir modal de edición
                  setOpen(false);
                  const t = selected;
                  setTimeout(() => {
                    try { console.log('[Contactos] Editar etiqueta desde filtro', t); } catch {}
                    setTagForm({ id: t?.id || null, name: t?.name || "", color: t?.color || "#60a5fa" });
                    setShowTagModal(true);
                  }, 0);
                }}
                disabled={!selected}
                style={{ background: "#1f2937", color: !selected ? "#64748b" : "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: ".35rem .6rem", cursor: !selected ? 'not-allowed' : 'pointer', fontSize: 13 }}
                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
              >Editar etiqueta</button>
              {(() => {
                // Calcular estado actual (todos tienen la etiqueta?) para toggling
                const idsArr = Array.from(selectedIds || []);
                const getTagId = (c) => {
                  const t = c.tag; if (t == null) return null; return typeof t === 'object' ? t.id : t;
                };
                const allHave = selected && idsArr.length > 0 && idsArr.every(id => {
                  const c = contacts.find(x => x.id === id);
                  return c && getTagId(c) === selected.id;
                });
                const label = allHave ? 'Quitar etiqueta masiva' : 'Agregar etiqueta masiva';
                return (
                  <button
                    type="button"
                    onClick={async () => {
                      if (!selected) return;
                      if (!idsArr.length) return;
                      setOpen(false);
                      try { console.log('[Contactos] Toggle etiqueta masiva', { selected, idsArr, allHave }); } catch {}
                      let ok = 0, fail = 0;
                      for (const id of idsArr) {
                        try {
                          const { data } = await api.patch(`contactos/${id}/`, { tag: allHave ? null : Number(selected.id) });
                          setContacts(prev => prev.map(c => c.id === id ? data : c));
                          ok++;
                        } catch (e) { /* continuar */ }
                          finally { /* nada */ }
                      }
                      try {
                        const msg = allHave
                          ? `Etiqueta removida en ${ok}/${idsArr.length} contacto(s)`
                          : `Etiqueta aplicada en ${ok}/${idsArr.length} contacto(s)`;
                        showToast(msg, ok === idsArr.length ? 'success' : (ok > 0 ? 'info' : 'warning'));
                      } catch {}
                    }}
                    disabled={!selected || !idsArr.length}
                    style={{ background: allHave ? '#dc2626' : '#0d9488', color: !selected || !idsArr.length ? '#164e63' : '#fff', border: `1px solid ${allHave ? '#b91c1c' : '#0f766e'}`, borderRadius: 8, padding: '.35rem .6rem', cursor: (!selected || !idsArr.length) ? 'not-allowed' : 'pointer', fontSize: 13 }}
                    title={allHave ? 'Quitar esta etiqueta de todos los seleccionados' : 'Asignar esta etiqueta a todos los seleccionados'}
                    onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                  >{label}</button>
                );
              })()}
              <button
                type="button"
                onClick={() => {
                  // Cerrar dropdown y abrir modal de creación
                  setOpen(false);
                  setTimeout(() => {
                    try { console.log('[Contactos] Crear etiqueta desde filtro'); } catch {}
                    setTagForm({ id: null, name: '', color: '#60a5fa' });
                    setShowTagModal(true);
                  }, 0);
                }}
                style={{ background: "#334155", color: "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: ".35rem .6rem", fontSize: 13 }}
                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
              >Crear nueva etiqueta</button>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Dropdown en cabecera para asignar etiqueta a seleccionados
  const TagAssignDropdown = ({ tags, disabled, onAssign }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
      document.addEventListener("mousedown", h);
      return () => document.removeEventListener("mousedown", h);
    }, []);
    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button
          type="button"
          onClick={() => !disabled && setOpen((o) => !o)}
          disabled={disabled}
          style={{ background: "#1f2937", color: "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: ".45rem .6rem", opacity: disabled ? .6 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
        >
          Etiquetas ▾
        </button>
        {open && (
          <div style={{ position: "absolute", top: "100%", left: 0, marginTop: 6, background: "#0f172a", border: "1px solid #2a3547", borderRadius: 8, minWidth: 240, zIndex: 80, boxShadow: "0 8px 24px rgba(0,0,0,.35)" }}>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              <div onClick={async () => { await onAssign(null); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>
                <span style={{ width: 10, height: 10, borderRadius: 9999, background: "#334155", display: "inline-block", border: "1px solid #2a3547" }} />
                <span>— Sin etiqueta —</span>
              </div>
              {tags.map((t) => (
                <div key={t.id} onClick={async () => { await onAssign(t.id); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>
                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: t.color || "#9ca3af", display: "inline-block", border: "1px solid #2a3547" }} />
                  <span>{t.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const ListFilterDropdown = ({ lists, value, onChange }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const handler = (e) => {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }, []);
    const selected = value === NO_LIST_FILTER_ID
      ? { id: NO_LIST_FILTER_ID, name: "Sin lista", color: "#94a3b8" }
      : (lists.find((l) => l.id === value) || null);
    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button type="button" onClick={() => setOpen((o) => !o)} style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: ".45rem .6rem", display: "inline-flex", alignItems: "center", gap: 6 }}>
          <span style={{ width: 10, height: 10, borderRadius: 9999, background: selected?.color || "#e5e7eb", display: "inline-block", border: "1px solid #e5e7eb" }} />
          <span style={{ fontSize: 14 }}>{selected ? selected.name : "Filtrar lista"}</span>
          <span style={{ opacity: 0.6 }}>▾</span>
        </button>
        {open && (
          <div style={{ position: "absolute", top: "100%", left: 0, marginTop: 6, background: "#0f172a", border: "1px solid #2a3547", borderRadius: 8, minWidth: 260, zIndex: 120, boxShadow: "0 8px 24px rgba(0,0,0,.35)" }}>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              <div onClick={() => { onChange(null); setOpen(false); }} style={{ padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>Todas</div>
              <div onClick={() => { onChange(NO_LIST_FILTER_ID); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>
                <span style={{ width: 10, height: 10, borderRadius: 9999, background: "#94a3b8", display: "inline-block", border: "1px solid #2a3547" }} />
                <span>Sin lista</span>
              </div>
              {lists.map((l) => (
                <div key={l.id} onClick={() => { onChange(l.id); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0" }}>
                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: l.color || "#9ca3af", display: "inline-block", border: "1px solid #2a3547" }} />
                  <span>{l.name}</span>
                </div>
              ))}
            </div>
            {/* Acciones de lista dentro del filtro */}
            <div
              style={{ padding: 10, borderTop: "1px solid #162033", display: "flex", gap: 8, justifyContent: "flex-end" }}
              onMouseDown={(e) => { e.stopPropagation(); }}
              onClick={(e) => { e.stopPropagation(); }}
            >
              <button
                type="button"
                onClick={() => {
                  if (!selected) return;
                  try { console.log('[Contactos] Editar lista desde filtro', selected); } catch {}
                  // Cerrar dropdown y abrir modal en el próximo tick para evitar cierres por mousedown global
                  setOpen(false);
                  const listId = selected.id;
                  const name = selected.name || '';
                  const color = selected.color || '#60a5fa';
                  setTimeout(() => {
                    try { console.log('[Contactos] Abrir modal editar lista (post-close dropdown)', { listId, name, color }); } catch {}
                    setEditingListId(listId);
                    setListEditForm({ name, color });
                    setShowListEditModal(true);
                  }, 0);
                }}
                disabled={!selected}
                style={{ background: "#1f2937", color: !selected ? "#64748b" : "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: ".35rem .6rem", cursor: !selected ? 'not-allowed' : 'pointer', fontSize: 13 }}
                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
              >Editar lista</button>
              <button
                type="button"
                onClick={() => {
                  try { console.log('[Contactos] Crear lista desde filtro'); } catch {}
                  setOpen(false);
                  setTimeout(() => {
                    setListCreateForm({ name: '', description: '', color: '#22c55e' });
                    setShowListCreateModal(true);
                  }, 0);
                }}
                style={{ background: "#334155", color: "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: ".35rem .6rem", fontSize: 13 }}
                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
              >Crear nueva lista</button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const ListDropdown = ({ lists, value, onChange, placeholder = "— Selecciona —", allowNull = false, excludeId = null, variant = "light", style }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
      const h = (e) => {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", h);
      return () => document.removeEventListener("mousedown", h);
    }, []);
    const items = lists.filter((l) => !excludeId || l.id !== excludeId);
    const selected = items.find((l) => l.id === value);
    const isDark = variant === "dark";
    const baseBtn = {
      background: isDark ? "#1f2937" : "#f9fafb",
      color: isDark ? "#fff" : "#111827",
      border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}`,
      borderRadius: 8,
      padding: ".45rem .6rem",
      fontSize: 14,
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      cursor: "pointer",
      ...style,
    };
    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button type="button" onClick={() => setOpen((o) => !o)} style={baseBtn}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <span style={{ width: 10, height: 10, borderRadius: 9999, background: selected?.color || (isDark ? "#334155" : "#e5e7eb"), display: "inline-block", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}` }} />
            <span>{selected ? selected.name : placeholder}</span>
          </span>
          <span style={{ opacity: 0.6 }}>▾</span>
        </button>
        {open && (
          <div style={{ position: "absolute", top: "100%", left: 0, marginTop: 6, background: isDark ? "#0f172a" : "#ffffff", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}`, borderRadius: 8, minWidth: 240, zIndex: 70, boxShadow: "0 8px 24px rgba(0,0,0,.25)" }}>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              {allowNull && (
                <div onClick={() => { onChange(null); setOpen(false); }} style={{ padding: "8px 10px", cursor: "pointer", borderBottom: `1px solid ${isDark ? "#162033" : "#f1f5f9"}` }}>— Ninguna —</div>
              )}
              {items.map((l) => (
                <div key={l.id} onClick={() => { onChange(l.id); setOpen(false); }} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", cursor: "pointer", borderBottom: `1px solid ${isDark ? "#162033" : "#f1f5f9"}` }}>
                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: l.color || "#9ca3af", display: "inline-block", border: `1px solid ${isDark ? "#2a3547" : "#e5e7eb"}` }} />
                  <span>{l.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Dropdown por fila para gestionar membresía en listas (toggle por lista)
  const RowListsDropdown = ({ contactId }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const [busy, setBusy] = useState(false);
    useEffect(() => {
      const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
      document.addEventListener("mousedown", h);
      return () => document.removeEventListener("mousedown", h);
    }, []);
    const isMember = (l) => Array.isArray(l.contacts) && l.contacts.includes(contactId);
    const toggle = async (listId) => {
      if (busy) return;
      setBusy(true);
      try {
        const { data: l } = await api.get(`listas/${listId}/`);
        const member = Array.isArray(l.contacts) && l.contacts.includes(contactId);
        const nextIds = member
          ? (l.contacts || []).filter((id) => id !== contactId)
          : Array.from(new Set([...(l.contacts || []), contactId]));
        await api.patch(`listas/${listId}/`, { contacts: nextIds });
        // Refrescar todas las listas para que se refleje la membresía
        const res = await api.get("listas/");
        setLists(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        alert("No se pudo actualizar la membresía en la lista.");
      } finally {
        setBusy(false);
      }
    };
    return (
      <div ref={ref} style={{ position: "relative" }}>
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          disabled={busy}
          style={{ background: "#1f2937", color: "#fff", border: "1px solid #2a3547", borderRadius: 8, padding: ".35rem .55rem", fontSize: 13, cursor: busy ? "not-allowed" : "pointer" }}
        >
          Listas ▾
        </button>
        {open && (
          <div style={{ position: "absolute", top: "100%", left: 0, marginTop: 6, background: "#0f172a", border: "1px solid #2a3547", borderRadius: 8, minWidth: 220, zIndex: 120, boxShadow: "0 8px 24px rgba(0,0,0,.35)" }}>
            <div style={{ maxHeight: 260, overflowY: "auto" }}>
              {lists.map((l) => {
                const member = isMember(l);
                return (
                  <div key={l.id} onClick={() => toggle(l.id)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "8px 10px", cursor: busy ? "not-allowed" : "pointer", borderBottom: "1px solid #162033", color: "#e2e8f0", opacity: busy ? 0.6 : 1 }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                      <span style={{ width: 10, height: 10, borderRadius: 9999, background: l.color || "#9ca3af", display: "inline-block", border: "1px solid #2a3547" }} />
                      <span>{l.name}</span>
                    </span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ opacity: member ? 1 : 0.25 }}>{member ? "✓" : "✓"}</span>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  // ================ Helpers principales ================
  const refreshLists = async (selectId = activeListId) => {
    try {
      const res = await api.get("listas/");
      const arr = Array.isArray(res.data) ? res.data : [];
      setLists(arr);
      const target = selectId || null;
      if (target) {
        try {
          const { data } = await api.get(`listas/${target}/`);
          setActiveListId(target);
          setActiveList(data);
        } catch {
          setActiveListId(null);
          setActiveList(null);
        }
      }
    } catch {}
  };

  const openListFromCards = (listId) => {
    if (!listId) return;
    const selected = (lists || []).find((l) => l.id === listId) || null;
    setActiveListFilterId(null);
    setActiveListId(listId);
    setActiveList(selected);
    setListDetailQ("");
    setContactsViewTab("lists");
  };

  const openAddContactsModal = () => {
    if (!activeListId || !activeList) return;
    setAddContactsQ("");
    setAddContactsSelectedIds(new Set());
    setAddContactsError("");
    setShowAddContactsModal(true);
  };

  const submitAddContactsToList = async () => {
    if (!activeListId || addContactsSelectedIds.size === 0) return;
    setIsAddContactsBusy(true);
    setAddContactsError("");
    try {
      const { data: latest } = await api.get(`listas/${activeListId}/`);
      const nextIds = Array.from(new Set([...(latest?.contacts || []), ...Array.from(addContactsSelectedIds)]));
      await api.patch(`listas/${activeListId}/`, { contacts: nextIds });
      await refreshLists(activeListId);
      setShowAddContactsModal(false);
      setAddContactsQ("");
      setAddContactsSelectedIds(new Set());
    } catch (e) {
      const msg = e?.response?.data;
      setAddContactsError(typeof msg === "string" ? msg : (msg?.detail || "No se pudieron agregar los contactos a la lista."));
    } finally {
      setIsAddContactsBusy(false);
    }
  };

  const clearListLongPress = () => {
    if (listLongPressTimerRef.current) {
      window.clearTimeout(listLongPressTimerRef.current);
      listLongPressTimerRef.current = null;
    }
  };

  const startListLongPress = (contactId) => {
    if (listSelectionMode) return;
    listLongPressTriggeredRef.current = false;
    clearListLongPress();
    listLongPressTimerRef.current = window.setTimeout(() => {
      listLongPressTriggeredRef.current = true;
      setListSelectionMode(true);
      setListSelectedIds((prev) => {
        const next = new Set(prev);
        next.add(contactId);
        return next;
      });
      listLongPressTimerRef.current = null;
    }, 420);
  };

  const removeSelectedFromActiveList = async () => {
    if (!activeListId || listSelectedIds.size === 0 || listSelectionBusy) return;
    const listName = activeList?.name || "esta lista";
    const ok = window.confirm(`¿Quitar ${listSelectedIds.size} contacto(s) de la lista "${listName}"?\nLos contactos no se eliminarán globalmente.`);
    if (!ok) return;
    setListSelectionBusy(true);
    try {
      const { data: latest } = await api.get(`listas/${activeListId}/`);
      const selectedSet = new Set(Array.from(listSelectedIds));
      const nextIds = (latest?.contacts || []).filter((id) => !selectedSet.has(id));
      await api.patch(`listas/${activeListId}/`, { contacts: nextIds });
      await refreshLists(activeListId);
      setListSelectedIds(new Set());
      setListSelectionMode(false);
    } catch (e) {
      alert("No se pudieron quitar los contactos seleccionados de la lista.");
    } finally {
      setListSelectionBusy(false);
    }
  };

  // Cargar contactos / tags / listas (similar al original; respeta filtros tag/has_note)
  useEffect(() => {
    let ignore = false;
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const params = new URLSearchParams();
        if (activeTagId) params.set("tag", activeTagId);
        if (noteFilter === "with") params.set("has_note", "true");
        if (noteFilter === "without") params.set("has_note", "false");
        const qurl = params.toString() ? `contactos/?${params.toString()}` : "contactos/";
        const { data } = await api.get(qurl);
        if (!ignore) setContacts(Array.isArray(data) ? data : []);
        const resLists = await api.get("listas/");
        if (!ignore) {
          const arr = Array.isArray(resLists.data) ? resLists.data : [];
          setLists(arr);
        }
        const resTags = await api.get("tags/");
        if (!ignore) setTags(Array.isArray(resTags.data) ? resTags.data : []);
      } catch (e) {
        if (!ignore) setError("No se pudieron cargar los contactos.");
      } finally {
        if (!ignore) setLoading(false);
      }
    };
    load();
    return () => {
      ignore = true;
    };
  }, [activeTagId, noteFilter]);

  // ================ Filtrado y paginación ================
  const normalizePhoneKey = (phone) => String(phone || "").replace(/\D/g, "");
  const duplicatePhoneKeys = new Set();
  const duplicateContactIds = new Set();
  const phoneCounts = new Map();
  (contacts || []).forEach((c) => {
    const key = normalizePhoneKey(c.phone);
    if (!key) return;
    phoneCounts.set(key, (phoneCounts.get(key) || 0) + 1);
  });
  phoneCounts.forEach((count, key) => {
    if (count > 1) duplicatePhoneKeys.add(key);
  });
  (contacts || []).forEach((c) => {
    const key = normalizePhoneKey(c.phone);
    if (duplicatePhoneKeys.has(key)) duplicateContactIds.add(c.id);
  });
  const duplicateContactsCount = duplicateContactIds.size;

  const filtered = contacts.filter((c) => {
    const t = (q || "").toString().toLowerCase();
    const name = (c.full_name || "").toString().toLowerCase();
    const phone = (c.phone || "").toString().toLowerCase();
    const matchText = name.includes(t) || phone.includes(t);
    if (!matchText) return false;
    if (activeDuplicateFilter && !duplicateContactIds.has(c.id)) return false;
    if (activeListFilterId === NO_LIST_FILTER_ID) {
      const assignedIds = new Set((lists || []).flatMap((l) => Array.isArray(l.contacts) ? l.contacts : []));
      return !assignedIds.has(c.id);
    }
    if (activeListFilterId) {
      const l = (lists || []).find((x) => x.id === activeListFilterId);
      const ids = new Set((l?.contacts || []));
      return ids.has(c.id);
    }
    return true;
  });

  const totalPagesTop = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentTop = Math.min(pageTop, totalPagesTop);
  const startTop = (currentTop - 1) * pageSize;
  const pagedTop = filtered.slice(startTop, startTop + pageSize);

  useEffect(() => {
    setPageTop(1);
  }, [q]);

  useEffect(() => {
    const loadActive = async () => {
      if (!activeListId) {
        setActiveList(null);
        return;
      }
      try {
        const { data } = await api.get(`listas/${activeListId}/`);
        setActiveList(data);
      } catch (e) {
        setActiveList(null);
        const status = e?.response?.status;
        if (status === 404) {
          setLists((prev) => prev.filter((l) => l.id !== activeListId));
          setActiveListId(null);
          try {
            const res = await api.get("listas/");
            const arr = Array.isArray(res.data) ? res.data : [];
            setLists(arr);
          } catch {}
        }
      }
    };
    loadActive();
  }, [activeListId]);

  // Derivar y paginar contactos de la lista activa
  const activeListContacts = (activeList?.contacts || []).map((cid) => contacts.find((x) => x.id === cid)).filter(Boolean);
  const filteredListContacts = activeListContacts.filter((c) => {
    const t = (listDetailQ || "").toString().toLowerCase();
    const name = (c.full_name || "").toString().toLowerCase();
    const phone = (c.phone || "").toString().toLowerCase();
    return name.includes(t) || phone.includes(t);
  });
  const listTotalCount = activeListContacts.length;
  const listWithWhatsappCount = activeListContacts.filter((c) => String(c.phone || "").trim().length > 0).length;
  const listWithoutWhatsappCount = Math.max(0, listTotalCount - listWithWhatsappCount);
  const activeListContactIds = new Set(activeList?.contacts || []);
  const availableContactsForActiveList = (contacts || []).filter((c) => !activeListContactIds.has(c.id));
  const filteredAvailableContactsForActiveList = availableContactsForActiveList.filter((c) => {
    const t = (addContactsQ || "").toString().toLowerCase().trim();
    if (!t) return true;
    const name = (c.full_name || "").toString().toLowerCase();
    const phone = (c.phone || "").toString().toLowerCase();
    return name.includes(t) || phone.includes(t);
  });
  const allVisibleAddContactsSelected = filteredAvailableContactsForActiveList.length > 0
    && filteredAvailableContactsForActiveList.every((c) => addContactsSelectedIds.has(c.id));
  const totalPagesBottom = Math.max(1, Math.ceil(filteredListContacts.length / pageSize));
  const currentBottom = Math.min(pageBottom, totalPagesBottom);
  const startBottom = (currentBottom - 1) * pageSize;
  const pagedBottom = filteredListContacts.slice(startBottom, startBottom + pageSize);

  useEffect(() => {
    setPageBottom(1);
  }, [listDetailQ, activeListId]);

  useEffect(() => {
    setListSelectionMode(false);
    setListSelectedIds(new Set());
    clearListLongPress();
  }, [activeListId, contactsViewTab]);

  useEffect(() => {
    return () => clearListLongPress();
  }, []);

  const allVisibleListSelected = pagedBottom.length > 0 && pagedBottom.every((c) => listSelectedIds.has(c.id));
  const selectedInActiveListCount = activeListContacts.filter((c) => listSelectedIds.has(c.id)).length;
  const listGridCols = listSelectionMode ? "grid-cols-[44px_2.2fr_1.5fr_1.5fr_auto]" : "grid-cols-[2.2fr_1.5fr_1.5fr_auto]";

  const Pagination = ({ page, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;
    const btnStyle = { background: "#1f2937", color: "#e2e8f0", border: "1px solid #2a3547", borderRadius: 8, padding: "0.35rem 0.6rem" };
    const numStyle = (n) => ({
      ...btnStyle,
      background: n === page ? "#0d6efd" : "#1f2937",
      borderColor: n === page ? "#2563eb" : "#2a3547",
    });
    // Calcular rango de páginas a mostrar (ventana)
    const windowSize = 5;
    let start = Math.max(1, page - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - windowSize + 1);
    }
    const pages = [];
    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push("...");
    }
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, padding: "0.6rem 0.4rem", flexWrap: "wrap" }}>
        <button onClick={() => onPageChange(1)} disabled={page <= 1} style={btnStyle}>« Primera</button>
        <button onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page <= 1} style={btnStyle}>‹ Anterior</button>
        {pages.map((p, idx) => (typeof p === "number" ? (<button key={p} onClick={() => onPageChange(p)} style={numStyle(p)}>{p}</button>) : (<span key={`dots-${idx}`} style={{ color: "#94a3b8", padding: "0 .25rem" }}>…</span>)))}
        <button onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page >= totalPages} style={btnStyle}>Siguiente ›</button>
        <button onClick={() => onPageChange(totalPages)} disabled={page >= totalPages} style={btnStyle}>Última »</button>
      </div>
    );
  };

  // ================ Renderizado ================
  return (
    <div className="ws-page ws-page-contactos min-h-screen flex bg-gray-100 dark:bg-gray-900 transition-colors duration-500">
      <Sidebar />

      <main className="ws-main flex-1 p-8 bg-gray-50 dark:bg-gray-900 transition-colors duration-500">
        <section className="mb-4 px-1">
          <h1 className="text-[32px] font-bold leading-tight text-gray-900 dark:text-gray-100">Contactos</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Gestiona tu base de clientes</p>
        </section>

        <section className="mb-4">
          <div className="inline-flex items-center gap-1.5 rounded-xl border border-[#2a3b54] bg-[#182336] p-1.5 shadow-[inset_0_1px_0_rgba(148,163,184,0.12)]">
            <button
              type="button"
              onClick={() => {
                setContactsViewTab("contacts");
                setActiveListId(null);
                setActiveList(null);
                setListDetailQ("");
              }}
              className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition ${
                contactsViewTab === "contacts"
                  ? "bg-[#101a2b] text-gray-100 shadow-[inset_0_1px_0_rgba(148,163,184,0.2)]"
                  : "text-[#9cb0c8] hover:bg-[#1f2a3d]"
              }`}
            >
              <FaAddressBook className="text-xs" />
              Contactos
              <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${contactsViewTab === "contacts" ? "bg-emerald-500/20 text-emerald-300" : "bg-[#2a3b54] text-[#9cb0c8]"}`}>
                {filtered.length}
              </span>
            </button>

            <button
              type="button"
              onClick={() => setContactsViewTab("lists")}
              className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition ${
                contactsViewTab === "lists"
                  ? "bg-[#101a2b] text-gray-100 shadow-[inset_0_1px_0_rgba(148,163,184,0.2)]"
                  : "text-[#9cb0c8] hover:bg-[#1f2a3d]"
              }`}
            >
              <FaListUl className="text-xs" />
              Listas
              <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${contactsViewTab === "lists" ? "bg-emerald-500/20 text-emerald-300" : "bg-[#2a3b54] text-[#9cb0c8]"}`}>
                {lists.length}
              </span>
            </button>
          </div>
        </section>

        {contactsViewTab === "contacts" && (
        <>
        <section className="mb-3 flex flex-wrap items-center gap-3">
          <button
            type="button"
            onClick={() => { try { console.log('[Contactos] Click Crear cliente'); } catch {}; setShowForm(true); }}
            className="inline-flex items-center gap-2 rounded-lg bg-[#22c55e] px-4 py-2 text-sm font-semibold text-[#052e16] transition hover:bg-[#16a34a]"
          >
            <FaUserPlus className="text-xs" /> Crear cliente
          </button>
          <button
            type="button"
            onClick={() => { try { console.log('[Contactos] Click Importar'); } catch {}; setShowImport(true); }}
            className="inline-flex items-center gap-2 rounded-lg border border-amber-500 bg-[#111c2e] px-4 py-2 text-sm font-semibold text-amber-400 transition hover:bg-[#15243a]"
          >
            <FaFileImport className="text-xs" /> Importar
          </button>
        </section>

        {/* Barra principal de controles */}
        <section className="mb-4 rounded-2xl border border-[#22344c] bg-[#0d1728] p-3 shadow-[inset_0_1px_0_rgba(148,163,184,0.08)]">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex min-w-[260px] flex-1 items-center gap-2 rounded-xl border border-[#2f425f] bg-gradient-to-r from-[#1c2a3f] to-[#28364a] px-3 py-2.5 transition-colors duration-300">
            <FaSearch className="text-xs text-[#8fa1bd]" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar por nombre o teléfono..."
              className="flex-1 bg-transparent border-none outline-none text-gray-100 placeholder-gray-400"
            />
          </div>
            <span className="whitespace-nowrap text-xs font-medium text-[#8fa1bd]">
              {filtered.length} contacto{filtered.length !== 1 ? "s" : ""}
            </span>
            <div ref={actionsRef} style={{ display: "flex", alignItems: "center", gap: 8, position: 'relative' }}>

              <div
                style={{ position: "relative" }}
                onMouseEnter={openActionsBubble}
                onMouseLeave={scheduleCloseActionsBubble}
              >
                <button
                  onClick={() => setShowActions((v) => !v)}
                  disabled={isBatching}
                  title="Acciones"
                  aria-haspopup="menu"
                  aria-expanded={showActions}
                  style={{
                    width: 36,
                    height: 36,
                    background: showActions ? "#0f172a" : "#1f2937",
                    color: "#e2e8f0",
                    border: "1px solid #2a3547",
                    borderRadius: 9999,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 14,
                    letterSpacing: "1px",
                    boxShadow: showActions ? "0 0 0 1px rgba(37,211,102,0.2)" : "none",
                    cursor: isBatching ? "not-allowed" : "pointer",
                  }}
                >
                  ...
                </button>
              </div>
              {selectedIds.size > 0 && (
                <span className="text-xs font-medium text-gray-300 whitespace-nowrap">
                  Seleccionados: {selectedIds.size}
                </span>
              )}
              {showActions && (
                <div
                  onMouseEnter={openActionsBubble}
                  onMouseLeave={scheduleCloseActionsBubble}
                  style={{
                    position: "absolute",
                    top: "calc(100% + 8px)",
                    right: 0,
                    background: "#0f172a",
                    border: "1px solid #2a3547",
                    borderRadius: 12,
                    minWidth: 210,
                    zIndex: 40,
                    fontSize: "12px",
                    lineHeight: 1.25,
                    boxShadow: "0 10px 26px rgba(0,0,0,.35)",
                  }}
                >
                  {/* Acciones con etiqueta */}
                  <button
                    onClick={() => {
                      setQ("");
                      setActiveTagId("");
                      setActiveListFilterId(null);
                      setActiveListId(null);
                      setActiveList(null);
                      setActiveDuplicateFilter(false);
                      setShowActions(false);
                    }}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: "#e2e8f0", border: "none", padding: "8px 10px", cursor: "pointer" }}
                  >
                    🧾 Ver todos los contactos
                  </button>
                  <button
                    onClick={() => {
                      // Requiere una etiqueta seleccionada en el filtro superior
                      if (!activeTagId || activeTagId === '__none__') return;
                      const tagIdNum = Number(activeTagId);
                      const withTag = filtered.filter((c) => c.tag === tagIdNum).map((c) => c.id);
                      if (withTag.length === 0) return;
                      setSelectedIds(new Set(withTag));
                      setListForm({ mode: "new", name: "", listId: null, color: listForm.color });
                      setListModalMove(false);
                      setTagActionMode('save');
                      setTagActionTagId(tagIdNum);
                      setShowListModal(true);
                      setShowActions(false);
                    }}
                    disabled={!activeTagId || activeTagId === '__none__' || filtered.filter((c) => c.tag === Number(activeTagId)).length === 0}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: (!activeTagId || activeTagId === '__none__' || filtered.filter((c) => c.tag === Number(activeTagId)).length === 0) ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: (!activeTagId || activeTagId === '__none__' || filtered.filter((c) => c.tag === Number(activeTagId)).length === 0) ? "not-allowed" : "pointer" }}
                  >
                    🏷️ Guardar con etiqueta en lista
                  </button>
                  {activeListId && (
                    <button
                      onClick={() => {
                        if (!activeTagId || activeTagId === '__none__') return;
                        const tagIdNum = Number(activeTagId);
                        const withTag = filtered.filter((c) => c.tag === tagIdNum).map((c) => c.id);
                        if (withTag.length === 0) return;
                        setSelectedIds(new Set(withTag));
                        setListForm({ mode: "existing", name: "", listId: null, color: listForm.color });
                        setListModalMove(true);
                        setTagActionMode('move');
                        setTagActionTagId(tagIdNum);
                        setShowListModal(true);
                        setShowActions(false);
                      }}
                      disabled={!activeTagId || activeTagId === '__none__' || filtered.filter((c) => c.tag === Number(activeTagId)).length === 0}
                      style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: (!activeTagId || activeTagId === '__none__' || filtered.filter((c) => c.tag === Number(activeTagId)).length === 0) ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: (!activeTagId || activeTagId === '__none__' || filtered.filter((c) => c.tag === Number(activeTagId)).length === 0) ? "not-allowed" : "pointer" }}
                    >
                      🏷️🔀 Mover con etiqueta a otra lista…
                    </button>
                  )}
                  <button
                    onClick={() => {
                      if (filtered.length === 0) return;
                      setSelectedIds(new Set(filtered.map((c) => c.id)));
                      setShowActions(false);
                    }}
                    disabled={filtered.length === 0}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: filtered.length === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: filtered.length === 0 ? "not-allowed" : "pointer" }}
                  >
                    ✅ Seleccionar todo el filtro ({filtered.length})
                  </button>
                  {/* Opción de quitar seleccionados de la lista eliminada según solicitud */}
                  <button
                    onClick={() => { setSelectedIds(new Set()); setShowActions(false); }}
                    disabled={selectedIds.size === 0}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: selectedIds.size === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: selectedIds.size === 0 ? "not-allowed" : "pointer" }}
                  >
                    ❎ Limpiar selección
                  </button>
                  <button
                    onClick={async () => {
                      if (selectedIds.size === 0 || isBatching) return;
                      const ok = window.confirm(`Eliminar ${selectedIds.size} contacto(s)? Esta acción no se puede deshacer.`);
                      if (!ok) return;
                      setIsBatching(true);
                      try {
                        const ids = Array.from(selectedIds);
                        await Promise.all(ids.map((id) => api.delete(`contactos/${id}/`)));
                        setContacts((prev) => prev.filter((c) => !selectedIds.has(c.id)));
                        setSelectedIds(new Set());
                      } catch (e) {
                        alert("No se pudieron eliminar algunos contactos.");
                      } finally {
                        setIsBatching(false);
                        setShowActions(false);
                      }
                    }}
                    disabled={selectedIds.size === 0 || isBatching}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: selectedIds.size === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: selectedIds.size === 0 ? "not-allowed" : "pointer" }}
                  >
                    🗑️ Eliminar seleccionados
                  </button>
                  <button
                    onClick={() => {
                      if (selectedIds.size === 0) return;
                      const rows = contacts.filter((c) => selectedIds.has(c.id));
                      const header = ["full_name", "phone", "created_at"];
                      const csv = [
                        header.join(","),
                        ...rows.map((r) => header.map((k) => {
                          const v = r[k] ?? "";
                          const s = String(v).replaceAll('"', '""');
                          return `"${s}"`;
                        }).join(",")),
                      ].join("\n");
                      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      const ts = new Date().toISOString().slice(0,19).replace(/[:T]/g, "-");
                      a.download = `contactos-${ts}.csv`;
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                      setShowActions(false);
                    }}
                    disabled={selectedIds.size === 0}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: selectedIds.size === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: selectedIds.size === 0 ? "not-allowed" : "pointer" }}
                  >
                    ⬇️ Exportar seleccionados (CSV)
                  </button>
                  <button
                    onClick={() => {
                      if (selectedIds.size === 0) return;
                      setListForm({ mode: "new", name: "", listId: null });
                      setListModalMove(false);
                      setShowListModal(true);
                      setShowActions(false);
                    }}
                    disabled={selectedIds.size === 0}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: selectedIds.size === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: selectedIds.size === 0 ? "not-allowed" : "pointer" }}
                  >
                    🗂️ Guardar seleccionados en lista
                  </button>
                  <button
                    onClick={() => {
                      setActiveDuplicateFilter((prev) => !prev);
                      setShowActions(false);
                    }}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: duplicateContactsCount === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: duplicateContactsCount === 0 ? "not-allowed" : "pointer" }}
                    disabled={duplicateContactsCount === 0}
                  >
                    {activeDuplicateFilter ? '📋 Ver todos los contactos' : `📋 Mostrar contactos duplicados (${duplicateContactsCount})`}
                  </button>
                  {/* Borrar todos los contactos de la lista activa (definitivo) */}
                  {((activeListFilterId && activeListFilterId !== NO_LIST_FILTER_ID) || activeListId) && (
                    <button
                      onClick={async () => {
                        const lid = activeListFilterId || activeListId;
                        if (!lid) return;
                        const ok = window.confirm('Eliminar TODOS los contactos de esta lista? Esta acción es permanente.');
                        if (!ok) return;
                        try {
                          const { data } = await api.post('contactos/delete-by-list/', { list_id: lid });
                          // Remover de estado local
                          setContacts(prev => prev.filter(c => !(c.lists || []).includes(lid)));
                          // Refrescar listas
                          try { const resAll = await api.get('listas/'); setLists(resAll.data || []); } catch {}
                          setSelectedIds(new Set());
                        } catch (e) {
                          alert('No se pudieron eliminar todos los contactos de la lista');
                        } finally {
                          setShowActions(false);
                        }
                      }}
                      style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: "#e2e8f0", border: "none", padding: "8px 10px", cursor: "pointer" }}
                    >
                      🗑️ Borrar contactos de la lista (definitivo)
                    </button>
                  )}
                  {/* Borrar todos los contactos con la etiqueta activa */}
                  {activeTagId && activeTagId !== '__none__' && (
                    <button
                      onClick={async () => {
                        const tid = Number(activeTagId);
                        if (!tid) return;
                        const ok = window.confirm('Eliminar TODOS los contactos con esta etiqueta? Acción permanente.');
                        if (!ok) return;
                        try {
                          const { data } = await api.post('contactos/delete-by-tag/', { tag_id: tid });
                          setContacts(prev => prev.filter(c => c.tag !== tid));
                          setSelectedIds(new Set());
                        } catch (e) {
                          alert('No se pudieron eliminar los contactos etiquetados');
                        } finally {
                          setShowActions(false);
                        }
                      }}
                      style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: "#e2e8f0", border: "none", padding: "8px 10px", cursor: "pointer" }}
                    >
                      🗑️ Borrar contactos etiquetados (definitivo)
                    </button>
                  )}
                  {activeListId && (
                    <button
                      onClick={() => {
                        if (selectedIds.size === 0) return;
                        setListForm({ mode: "existing", name: "", listId: null });
                        setListModalMove(true);
                        setShowListModal(true);
                        setShowActions(false);
                      }}
                      disabled={selectedIds.size === 0}
                      style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: selectedIds.size === 0 ? "#64748b" : "#e2e8f0", border: "none", padding: "8px 10px", cursor: selectedIds.size === 0 ? "not-allowed" : "pointer" }}
                    >
                      🔀 Mover seleccionados a otra lista…
                    </button>
                  )}
                  <button
                    onClick={() => {
                      setShowImport(true);
                      setShowActions(false);
                    }}
                    style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", color: "#e2e8f0", border: "none", padding: "8px 10px", cursor: "pointer" }}
                  >
                    📥 Importar contactos
                  </button>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Barra de acciones para la etiqueta seleccionada */}
        {false && activeTagId && (
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl px-4 py-3 mb-3 flex flex-wrap items-center gap-2">
            <span className="text-gray-900 dark:text-gray-100 mr-2">Etiqueta activa:</span>
            {(() => {
              const t = tags.find((x) => String(x.id) === String(activeTagId));
              return (
                <span
                  className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs"
                  style={{
                    borderColor: t?.color || "#e5e7eb",
                    color: t?.color || "#111827",
                    backgroundColor: `${t?.color || "#e5e7eb"}20`,
                  }}
                >
                  <span
                    className="w-2.5 h-2.5 rounded-full border border-gray-200 dark:border-gray-600"
                    style={{ backgroundColor: t?.color || "#e5e7eb" }}
                  />
                  {t?.name || "Etiqueta"}
                </span>
              );
            })()}
            <span className="text-gray-500 dark:text-gray-400 text-sm">
              ({contacts.filter((c) => c.tag === Number(activeTagId)).length} contactos)
            </span>

            <div className="ml-auto flex gap-2 flex-wrap">

              <button
                onClick={() => {
                  setShowActions(false);
                  const t = tags.find((x) => String(x.id) === String(activeTagId));
                  try { console.log('[Contactos] Editar etiqueta click', { activeTagId, t }); } catch {}
                  setTagForm({ id: t?.id || null, name: t?.name || "", color: t?.color || "#60a5fa" });
                  setShowTagModal(true);
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >Editar etiqueta</button>

              <button
                onClick={() => { try { console.log('[Contactos] Crear nueva etiqueta click'); } catch {}; setShowActions(false); setTagForm({ id: null, name: '', color: '#60a5fa' }); setShowTagModal(true); }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >Crear nueva etiqueta</button>

              <button
                onClick={async () => {
                  const tagIdNum = Number(activeTagId);
                  if (!tagIdNum) return;
                  const ok = window.confirm(
                    "¿Eliminar esta etiqueta? Se quitará de los contactos, pero no se eliminarán los contactos."
                  );
                  if (!ok) return;
                  setIsTagBusy(true);
                  try {
                    await api.delete(`tags/${tagIdNum}/`);
                    const res = await api.get("tags/");
                    setTags(Array.isArray(res.data) ? res.data : []);
                    setActiveTagId("");
                    const rs = await api.get("contactos/");
                    setContacts(Array.isArray(rs.data) ? rs.data : []);
                  } catch (e) {
                    alert("No se pudo eliminar la etiqueta.");
                  } finally {
                    setIsTagBusy(false);
                  }
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
              >Eliminar etiqueta</button>
            </div>
          </div>
        )}

        {false && activeDuplicateFilter && (
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl px-4 py-3 mb-3 flex flex-wrap items-center gap-2">
            <span className="text-gray-900 dark:text-gray-100 mr-2">Filtro activo:</span>
            <span className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs border-amber-300 text-amber-700 bg-amber-50 dark:border-amber-700 dark:text-amber-300 dark:bg-amber-900/30">
              Contactos duplicados
            </span>
            <span className="text-gray-500 dark:text-gray-400 text-sm">({duplicateContactsCount} contactos)</span>
            <div className="ml-auto flex gap-2 flex-wrap">
              <button
                onClick={() => setActiveDuplicateFilter(false)}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >
                Ver todos
              </button>
            </div>
          </div>
        )}

        {/* Barra de acciones para la lista filtrada (similar a la de etiqueta activa) */}
        {false && activeListFilterId && activeListFilterId !== NO_LIST_FILTER_ID && (
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl px-4 py-3 mb-3 flex flex-wrap items-center gap-2">
            <span className="text-gray-900 dark:text-gray-100 mr-2">Lista activa:</span>
            {(() => {
              const l = lists.find((x) => x.id === activeListFilterId);
              return (
                <span
                  className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs cursor-pointer"
                  style={{
                    borderColor: l?.color || '#e5e7eb',
                    color: l?.color || '#111827',
                    backgroundColor: `${l?.color || '#e5e7eb'}20`,
                  }}
                  title="Ver contactos de esta lista"
                  onClick={() => { if (l) { setListMembersListId(l.id); setListMembersQ(''); /* modal aún deshabilitado */ } }}
                >
                  <span
                    className="w-2.5 h-2.5 rounded-full border border-gray-200 dark:border-gray-600"
                    style={{ backgroundColor: l?.color || '#e5e7eb' }}
                  />
                  {l?.name || 'Lista'}
                </span>
              );
            })()}
            <span className="text-gray-500 dark:text-gray-400 text-sm">
              ({(lists.find((x) => x.id === activeListFilterId)?.contacts?.length) || 0} contactos)
            </span>

            <div className="ml-auto flex gap-2 flex-wrap">
              <button
                onClick={() => {
                  const l = lists.find((x) => x.id === activeListFilterId);
                  if (!l) return;
                  setEditingListId(l.id);
                  setListEditForm({ name: l.name || '', color: l.color || '#60a5fa' });
                  setShowListEditModal(true);
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >
                Editar lista
              </button>

              <button
                onClick={() => {
                  setListCreateForm({ name: '', description: '', color: '#22c55e' });
                  setShowListCreateModal(true);
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >
                Crear nueva lista
              </button>

              <button
                onClick={async () => {
                  if (!activeListFilterId) return;
                  const l = lists.find((x) => x.id === activeListFilterId);
                  const ok = window.confirm(`¿Eliminar la lista "${l?.name || ''}"? Los contactos no se borrarán.`);
                  if (!ok) return;
                  setIsListBusy(true);
                  try {
                    await api.delete(`listas/${activeListFilterId}/`);
                    await refreshLists(null);
                    setActiveListFilterId(null);
                    if (activeListId === activeListFilterId) {
                      setActiveListId(null);
                      setActiveList(null);
                    }
                  } catch (e) {
                    alert('No se pudo eliminar la lista.');
                  } finally {
                    setIsListBusy(false);
                  }
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
              >
                Eliminar lista
              </button>
            </div>
          </div>
        )}

        {/* Barra de acciones para la lista seleccionada */}
  {false && activeListId && !activeListFilterId && (
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl px-4 py-3 mb-3 flex flex-wrap items-center gap-2">
            <span className="text-gray-900 dark:text-gray-100 mr-2">Lista activa:</span>
            {(() => {
              const l = lists.find(x => x.id === activeListId);
              return (
                <span
                  className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs cursor-pointer"
                  style={{
                    borderColor: l?.color || '#e5e7eb', color: l?.color || '#111827', backgroundColor: `${l?.color || '#e5e7eb'}20`
                  }}
                  title="Ver contactos de esta lista"
                  onClick={() => { if (l) { setListMembersListId(l.id); setListMembersQ(''); setShowListMembers(true); } }}
                >
                  <span className="w-2.5 h-2.5 rounded-full border border-gray-200 dark:border-gray-600" style={{ backgroundColor: l?.color || '#e5e7eb' }} />
                  {l?.name || 'Lista'}
                </span>
              );
            })()}
            <span className="text-gray-500 dark:text-gray-400 text-sm">({(lists.find(x => x.id === activeListId)?.contacts?.length) || 0} contactos)</span>

            <div className="ml-auto flex gap-2 flex-wrap">
              {/* Botones de añadir/quitar seleccionados removidos según solicitud */}

              <button
                onClick={() => {
                  setShowActions(false);
                  const l = lists.find(x => x.id === activeListId);
                  if (!l) return;
                  try { console.log('[Contactos] Click Editar lista (barra lista activa)', l); } catch {}
                  setEditingListId(l.id);
                  setListEditForm({ name: l.name || '', color: l.color || '#60a5fa' });
                  setShowListEditModal(true);
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >Editar lista</button>

              <button
                onClick={() => { setShowActions(false); try { console.log('[Contactos] Click Crear nueva lista (barra lista activa)'); } catch {}; setListCreateForm({ name: '', description: '', color: '#22c55e' }); setShowListCreateModal(true); }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
                type="button"
              >Crear nueva lista</button>

              <button
                onClick={async () => {
                  if (!activeListId) return;
                  const ok = window.confirm('¿Eliminar esta lista? Los contactos no se borrarán.');
                  if (!ok) return;
                  setIsListBusy(true);
                  try {
                    await api.delete(`listas/${activeListId}/`);
                    await refreshLists(null);
                    setActiveListId(null);
                    setActiveListFilterId(null);
                  } catch (e) { alert('No se pudo eliminar la lista.'); }
                  finally { setIsListBusy(false); }
                }}
                className="bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-md px-3 py-1 text-sm"
              >Eliminar lista</button>
            </div>
          </div>
        )}

        {/* Tabla principal (pagedTop) */}
        <div className="bg-[#0f1c30] border border-[#2a3b54] rounded-xl overflow-hidden mb-3 transition-colors duration-300">
          <div className="grid grid-cols-[40px_2.6fr_1.8fr_1.8fr_1.6fr_1.3fr] px-4 py-3 bg-[#1f2d42] text-[#9db0c9] font-semibold uppercase tracking-wider text-[12px] border-b border-[#2a3b54] items-center">
            <div>
              <input
                type="checkbox"
                aria-label="Seleccionar todos"
                checked={pagedTop.length > 0 && pagedTop.every((c) => selectedIds.has(c.id))}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedIds((prev) => {
                      const next = new Set(prev);
                      pagedTop.forEach((c) => next.add(c.id));
                      return next;
                    });
                  } else {
                    setSelectedIds((prev) => {
                      const next = new Set(prev);
                      pagedTop.forEach((c) => next.delete(c.id));
                      return next;
                    });
                  }
                }}
              />
            </div>
            <div>Nombre</div>
            <div>Teléfono</div>
            <div>Listas</div>
            <div>Etiquetas</div>
            <div>Acciones</div>
          </div>

          {loading ? (
            <div className="py-5 text-center text-gray-500 dark:text-gray-400">Cargando contactos…</div>
          ) : error ? (
            <div className="py-5 text-center text-red-500">{error}</div>
          ) : filtered.length === 0 ? (
            <div className="py-5 text-center text-gray-500 dark:text-gray-400">No hay contactos.</div>
          ) : (
            pagedTop.map((c) => {
              const tag = tags.find((t) => t.id === c.tag);
              const member = (lists || []).filter((l) => Array.isArray(l.contacts) && l.contacts.includes(c.id));
              const initials = String(c.full_name || "C")
                .split(/\s+/)
                .filter(Boolean)
                .slice(0, 2)
                .map((x) => x[0])
                .join("")
                .toUpperCase();

              return (
                <div
                  key={c.id}
                  className="grid grid-cols-[40px_2.6fr_1.8fr_1.8fr_1.6fr_1.3fr] px-4 py-3 border-t border-gray-200 dark:border-gray-700 items-center hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors duration-300"
                >
                  <div>
                    <input
                      type="checkbox"
                      checked={selectedIds.has(c.id)}
                      onChange={(e) => {
                        setSelectedIds((prev) => {
                          const next = new Set(prev);
                          if (e.target.checked) next.add(c.id);
                          else next.delete(c.id);
                          return next;
                        });
                      }}
                      aria-label={`Seleccionar ${c.full_name}`}
                    />
                  </div>

                  <div className="flex items-center gap-2 min-w-0">
                    <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-[11px] font-semibold text-emerald-300">
                      {initials || "C"}
                    </span>
                    <span className="truncate text-sm font-semibold text-gray-100">{c.full_name}</span>
                  </div>

                  <div className="text-gray-100 font-mono tabular-nums tracking-wide text-sm">{c.phone}</div>

                  <div className="flex flex-wrap gap-1">
                    {member.length === 0 ? (
                      <span className="text-xs text-gray-500">—</span>
                    ) : (
                      member.slice(0, 2).map((l) => (
                        <span
                          key={l.id}
                          className="inline-flex items-center gap-1.5 px-2 py-0.5 border rounded-full text-[11px]"
                          style={{ borderColor: `${l.color || "#60a5fa"}88`, color: l.color || "#60a5fa", backgroundColor: `${l.color || "#60a5fa"}20` }}
                        >
                          <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: l.color || "#60a5fa" }} />
                          {l.name}
                        </span>
                      ))
                    )}
                  </div>

                  <div>
                    {tag ? (
                      <span
                        className="inline-flex items-center gap-1.5 px-2 py-0.5 border rounded-full text-[11px]"
                        style={{ borderColor: `${tag.color || "#22c55e"}88`, color: tag.color || "#22c55e", backgroundColor: `${tag.color || "#22c55e"}20` }}
                      >
                        <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: tag.color || "#22c55e" }} />
                        {tag.name || "Etiqueta"}
                      </span>
                    ) : (
                      <span className="text-xs text-gray-500">—</span>
                    )}
                  </div>

                  <div className="flex items-center gap-1.5">
                    <button
                      type="button"
                      className="inline-flex items-center gap-1 rounded-md border border-[#1e4f86] bg-[#18345e] px-2 py-1 text-xs font-semibold text-[#79beff] transition hover:bg-[#204477]"
                      onClick={() => {
                        try { console.log('[Contactos] Click Editar (fila principal)', c); } catch {}
                        const tokens = (c.full_name || "").trim().split(/\s+/);
                        let first = "";
                        let last = "";
                        if (tokens.length >= 2) {
                          last = tokens.pop();
                          first = tokens.join(" ");
                        } else if (tokens.length === 1) {
                          first = tokens[0];
                        }
                        let countryCode = "+593";
                        let local = c.phone || "";
                        if (local.startsWith("+")) {
                          const codes = [...COUNTRY_CODES.map((x) => x.code)].sort((a, b) => b.length - a.length);
                          const m = codes.find((code) => local.startsWith(code));
                          if (m) {
                            countryCode = m;
                            local = local.slice(m.length);
                          } else {
                            local = local.replace(/^\+/, "");
                          }
                        }
                        setEditForm({
                          id: c.id,
                          first_name: first,
                          last_name: last,
                          phone: local,
                          countryCode,
                        });
                        setEditError({});
                        setShowEdit(true);
                      }}
                    >
                      <FaEdit className="text-[10px]" />
                      Editar
                    </button>

                    <button
                      type="button"
                      className="inline-flex items-center gap-1 rounded-md border border-[#6b1e2a] bg-[#3a1520] px-2 py-1 text-xs font-semibold text-[#ff5f69] transition hover:bg-[#4a1a28]"
                      onClick={async () => {
                        if (!window.confirm("¿Eliminar este contacto?")) return;
                        try {
                          await api.delete(`contactos/${c.id}/`);
                          setContacts((p) => p.filter((x) => x.id !== c.id));
                          setSelectedIds((p) => {
                            const n = new Set(p);
                            n.delete(c.id);
                            return n;
                          });
                          if (activeListId) {
                            try {
                              const { data } = await api.get(`listas/${activeListId}/`);
                              setActiveList(data);
                            } catch {}
                          }
                        } catch {
                          alert("No se pudo eliminar el contacto.");
                        }
                      }}
                    >
                      <FaTrash className="text-[10px]" />
                      Eliminar
                    </button>
                  </div>
                </div>
              );
            })
          )}
        </div>


        <Pagination page={currentTop} totalPages={totalPagesTop} onPageChange={setPageTop} />
        <div className="mt-1 mb-3 text-xs text-gray-400">
          Mostrando {pagedTop.length} de {filtered.length} contactos en esta página
        </div>

  {/* Panel Lista Activa (oculto) */}
  <div style={{ display: "none", marginTop: 16, background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ color: "#111827" }}>Lista:</span>
              <ListDropdown lists={lists} value={activeListId} onChange={(id) => setActiveListId(id)} placeholder="— Ninguna —" allowNull={true} variant="light" />
              {activeList?.color && <span title={activeList?.name || "Lista"} style={{ display: "inline-block", width: 14, height: 14, borderRadius: 9999, background: activeList.color, border: "1px solid #e5e7eb" }} />}
              <span style={{ color: "#6b7280" }}>{activeList ? `(${activeList.contacts?.length || 0} contactos)` : "Sin lista seleccionada"}</span>
            </div>

            {activeList && !activeListFilterId && (
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button onClick={() => { if (!activeListId) return; const l = lists.find(x=>x.id===activeListId); if(!l) return; setEditingListId(l.id); setListEditForm({ name: l.name || "", color: l.color || "#60a5fa" }); setShowListEditModal(true); }} style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0.4rem 0.7rem" }}>Editar lista</button>
                <button onClick={() => { setListCreateForm({ name: '', description: '', color: '#22c55e' }); setShowListCreateModal(true); }} style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0.4rem 0.7rem" }}>Crear nueva lista</button>
                <button onClick={async () => {
                  if (!activeListId) return;
                  const ok = window.confirm("¿Eliminar esta lista? Los contactos no se borrarán.");
                  if (!ok) return;
                  setIsListBusy(true);
                  try {
                    await api.delete(`listas/${activeListId}/`);
                    await refreshLists(null);
                  } catch (e) { alert("No se pudo eliminar la lista."); } finally { setIsListBusy(false); }
                }} style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0.4rem 0.7rem" }}>Eliminar lista</button>
              </div>
            )}
          </div>

          {/* Buscador inferior */}
          <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ flex: 1, minWidth: 260, display: "flex", alignItems: "center", gap: "0.5rem", background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 9999, padding: "0.35rem 0.75rem", opacity: activeList ? 1 : 0.6 }}>
              <span style={{ opacity: 0.7 }}>🔍</span>
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar en la lista por nombre o teléfono" disabled={!activeList} style={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#111827" }} />
            </div>
          </div>

          {activeList && (
            <div style={{ marginTop: 8, background: "#ffffff", borderRadius: 8, border: "1px solid #e5e7eb" }}>
              <div style={{ display: "grid", gridTemplateColumns: "40px 2fr 1.2fr 1fr 1fr 1.2fr", padding: "0.6rem 0.8rem", color: "#111827", background: "#f3f4f6", alignItems: "center" }}>
                <div>
                  <input type="checkbox" aria-label="Seleccionar todos (página lista)" checked={pagedBottom.length > 0 && pagedBottom.every((c) => selectedIds.has(c.id))} onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedIds((prev) => {
                        const next = new Set(prev);
                        pagedBottom.forEach((c) => next.add(c.id));
                        return next;
                      });
                    } else {
                      setSelectedIds((prev) => {
                        const next = new Set(prev);
                        pagedBottom.forEach((c) => next.delete(c.id));
                        return next;
                      });
                    }
                  }} />
                </div>
                <div>Nombres y apellidos</div>
                <div>Teléfono</div>
                <div>Nota</div>
                <div>Etiqueta</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                  <span>Acciones</span>
                  <span style={{ color: "#94a3b8", fontSize: 12 }}>Seleccionados en esta página: {pagedBottom.filter((c) => selectedIds.has(c.id)).length}</span>
                </div>
              </div>

              {filteredListContacts.length === 0 ? (
                <div style={{ padding: "1rem", color: "#94a3b8", textAlign: "center" }}>Esta lista no tiene contactos.</div>
              ) : (
                pagedBottom.map((c) => {
                  const tag = tags.find((t) => t.id === c.tag);
                  const bg = tag ? `${tag.color}22` : "transparent";
                  const hasNote = !!(c.note && String(c.note).trim());
                  const open = openNoteIds.has(c.id);
                  return (
                    <div key={c.id} style={{ display: "grid", gridTemplateColumns: "40px 2fr 1.2fr 1fr 1fr 1.2fr", padding: "0.6rem 0.8rem", borderTop: "1px solid #e5e7eb", alignItems: "center", background: bg }}>
                      <div>
                        <input type="checkbox" checked={selectedIds.has(c.id)} onChange={(e) => {
                          setSelectedIds((prev) => {
                            const next = new Set(prev);
                            if (e.target.checked) next.add(c.id); else next.delete(c.id);
                            return next;
                          });
                        }} aria-label={`Seleccionar ${c.full_name}`} />
                      </div>

                      <div style={{ display: "flex", gap: 8, flexDirection: "column", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span>{c.full_name}</span>
                          {hasNote && (
                            <span title={(c.note || "").slice(0, 120)} role="button" tabIndex={0} onClick={() => {
                              setOpenNoteIds(prev => {
                                const next = new Set(prev);
                                if (next.has(c.id)) next.delete(c.id); else next.add(c.id);
                                return next;
                              });
                              setNoteDrafts(d => ({ ...d, [c.id]: (c.note || "") }));
                            }} style={{ fontSize: 14, cursor: "pointer" }}>📝</span>
                          )}
                        </div>

                        {/* Se eliminan etiquetas y listas duplicadas de esta columna para simplificar la fila */}
                      </div>

                      <div style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', letterSpacing: '0.02em' }}>{c.phone}</div>

                      <div>
                        <label style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 6px", borderRadius: 6 }}>
                          <div role="checkbox" tabIndex={0} aria-checked={open} aria-label={`Nota para ${c.full_name}`} onClick={() => {
                            setOpenNoteIds(prev => {
                              const next = new Set(prev);
                              if (next.has(c.id)) next.delete(c.id); else next.add(c.id);
                              return next;
                            });
                            setNoteDrafts(d => ({ ...d, [c.id]: (c.note || "") }));
                          }} style={{
                            width: 18, height: 18, borderRadius: 4, border: "1px solid #9ca3af",
                            background: hasNote ? "#16a34a" : "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", color: "#ffffff", fontSize: 12, fontWeight: 700, lineHeight: "18px", cursor: "pointer"
                          }} title={hasNote ? "Tiene nota" : "Sin nota"}>
                            {hasNote ? "✓" : ""}
                          </div>
                        </label>

                        {open && (
                          <div style={{ marginTop: 8, display: "grid", gap: 6 }}>
                            <textarea rows={3} value={noteDrafts[c.id] ?? ""} onChange={(e) => setNoteDrafts(d => ({ ...d, [c.id]: e.target.value }))} placeholder="Escribe una nota para este contacto..." style={{ width: "100%", background: "#ffffff", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: 8 }} />
                            <div style={{ display: "flex", gap: 8 }}>
                              <button type="button" onClick={async () => {
                                if (savingNoteIds.has(c.id)) return;
                                setSavingNoteIds(prev => { const n = new Set(prev); n.add(c.id); return n; });
                                try {
                                  const payload = { note: (noteDrafts[c.id] ?? "").trim() };
                                  const { data } = await api.patch(`contactos/${c.id}/`, payload);
                                  setContacts(prev => prev.map(x => x.id === c.id ? data : x));
                                  if (!payload.note) {
                                    setOpenNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; });
                                  }
                                } catch (e) { console.error(e); alert("No se pudo guardar la nota"); }
                                finally { setSavingNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; }); }
                              }} disabled={savingNoteIds.has(c.id)} style={{ background: "#0d6efd", color: "#fff", border: "none", borderRadius: 6, padding: ".35rem .6rem", opacity: savingNoteIds.has(c.id) ? 0.7 : 1 }}>{savingNoteIds.has(c.id) ? "Guardando…" : "Guardar"}</button>

                              {hasNote && (
                                <button type="button" onClick={async () => {
                                  if (savingNoteIds.has(c.id)) return;
                                  setSavingNoteIds(prev => { const n = new Set(prev); n.add(c.id); return n; });
                                  try {
                                    const { data } = await api.patch(`contactos/${c.id}/`, { note: "" });
                                    setContacts(prev => prev.map(x => x.id === c.id ? data : x));
                                    setOpenNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; });
                                  } catch (e) { console.error(e); alert("No se pudo eliminar la nota"); }
                                  finally { setSavingNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; }); }
                                }} disabled={savingNoteIds.has(c.id)} style={{ background: "#ef4444", color: "#fff", border: "none", borderRadius: 6, padding: ".35rem .6rem", opacity: savingNoteIds.has(c.id) ? 0.7 : 1 }}>Eliminar</button>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                          <TagDropdown tags={tags} value={c.tag ?? null} onChange={async (id) => {
                            const payload = { tag: id ? Number(id) : null };
                            try {
                              const { data } = await api.patch(`contactos/${c.id}/`, payload);
                              setContacts(prev => prev.map(x => x.id === c.id ? data : x));
                            } catch {
                              alert("No se pudo asignar la etiqueta.");
                            }
                          }} allowNull={true} variant="light" />
                          <RowListsDropdown contactId={c.id} />
                        </div>
                        {(() => {
                          const member = (Array.isArray(lists) ? lists : []).filter(l => Array.isArray(l.contacts) && l.contacts.includes(c.id));
                          if (!member.length) return <span style={{ fontSize: 11, color: '#6b7280' }}>Sin listas</span>;
                          const visible = member.slice(0, 2);
                          const extra = member.length - visible.length;
                          return (
                            <div style={{ marginTop: 2, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                              {visible.map(l => (
                                <span key={l.id} title={`Ver contactos de la lista: ${l.name}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '2px 6px', borderRadius: 9999, border: '1px solid #e5e7eb', background: '#f9fafb', color: '#111827', cursor: 'pointer' }} onClick={() => { setListMembersListId(l.id); setListMembersQ(''); setShowListMembers(true); }}>
                                  <span style={{ width: 10, height: 10, borderRadius: 9999, background: l.color || '#e5e7eb', display: 'inline-block', border: '1px solid #e5e7eb' }} />
                                  {l.name}
                                </span>
                              ))}
                              {extra > 0 && (
                                <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 6px', borderRadius: 9999, background: '#f3f4f6', color: '#4b5563', fontSize: 11 }}>+{extra}</span>
                              )}
                            </div>
                          );
                        })()}
                      </div>

                      <div style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
                        <button
                          type="button"
                          className="bg-gradient-to-r from-emerald-500 to-cyan-600 hover:from-emerald-600 hover:to-cyan-700 text-white rounded-md px-2 py-1 text-sm transition"
                          onClick={() => {
                            try { console.log('[Contactos] Click Editar (fila lista activa superior)', c); } catch {}
                          const tokens = (c.full_name || "").trim().split(/\s+/);
                          let first = ""; let last = "";
                          if (tokens.length >= 2) { last = tokens.pop(); first = tokens.join(" "); }
                          else if (tokens.length === 1) { first = tokens[0]; }
                          let countryCode = "+593";
                          let local = c.phone || "";
                          if (local.startsWith("+")) {
                            const codes = [...COUNTRY_CODES.map(x => x.code)].sort((a,b) => b.length - a.length);
                            const m = codes.find(code => local.startsWith(code));
                            if (m) { countryCode = m; local = local.slice(m.length); } else { local = local.replace(/^\+/, ""); }
                          }
                          setEditForm({ id: c.id, first_name: first, last_name: last, phone: local, countryCode });
                          setEditError({});
                          setShowEdit(true);
                        }}>Editar</button>

                        <button
                          type="button"
                          className="bg-gradient-to-r from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700 text-white rounded-md px-2 py-1 text-sm transition"
                          onClick={async () => {
                                                    if (!activeListId) return;
                          const listName = activeList?.name || "esta lista";
                          const ok = window.confirm(`¿Quitar este contacto de la lista "${listName}"?\nEl contacto no se eliminará globalmente.`);
                          if (!ok) return;
                          try {
                            const { data: l } = await api.get(`listas/${activeListId}/`);
                            const nextIds = (l.contacts || []).filter((id) => id !== c.id);
                            await api.patch(`listas/${activeListId}/`, { contacts: nextIds });
                            await refreshLists(activeListId);
                          } catch (e) {
                            alert("No se pudo quitar el contacto de la lista.");
                          }
                        }}
                      >
                        Quitar de lista
                      </button>
                    </div>
                  </div>
                ); })
              )}
            </div>
          )}
          {/* <Pagination page={currentTop} totalPages={totalPagesTop} onPageChange={setPageTop} /> */}

          {/* Cierre del panel oculto superior */}
          </div>

          {/* Panel de la lista activa (oculto) */}
          <div style={{ display: "none", marginTop: 16, background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ color: "#111827" }}>Lista:</span>
                <ListDropdown
                  lists={lists}
                  value={activeListId}
                  onChange={(id) => setActiveListId(id)}
                  placeholder="— Ninguna —"
                  allowNull={true}
                  variant="light"
                />
                {activeList?.color && (
                  <span title={activeList?.name || "Lista"} style={{ display: 'inline-block', width: 14, height: 14, borderRadius: 9999, background: activeList.color, border: '1px solid #e5e7eb' }} />
                )}
                <span style={{ color: "#6b7280" }}>
                  {activeList ? `(${activeList.contacts?.length || 0} contactos)` : "Sin lista seleccionada"}
                </span>
              </div>
              {activeList && (
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button
                    type="button"
                    onClick={() => {
                      setListEditForm({ name: activeList.name || "", color: activeList.color || "#60a5fa" });
                      setShowListEditModal(true);
                    }}
                    style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0.4rem 0.7rem" }}
                  >
                    Editar lista
                  </button>

                  <button
                    onClick={async () => {
                      if (!activeListId) return;
                      const ok = window.confirm("¿Eliminar esta lista? Los contactos no se borrarán.");
                      if (!ok) return;
                      setIsListBusy(true);
                      try {
                        await api.delete(`listas/${activeListId}/`);
                        await refreshLists(null);
                        setActiveListId(null);
                      } catch (e) {
                        alert("No se pudo eliminar la lista.");
                      } finally {
                        setIsListBusy(false);
                      }
                    }}
                    style={{ background: "#f9fafb", color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "0.4rem 0.7rem" }}
                  >
                    Eliminar lista
                  </button>
                </div>
              )}
            </div>

            {/* Buscador inferior */}
            <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ flex: 1, minWidth: 260, display: "flex", alignItems: "center", gap: "0.5rem", background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: 9999, padding: "0.35rem 0.75rem", opacity: activeList ? 1 : 0.6 }}>
                <span style={{ opacity: 0.7 }}>🔍</span>
                <input
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Buscar en la lista por nombre o teléfono"
                  disabled={!activeList}
                  style={{ flex: 1, background: "transparent", border: "none", outline: "none", color: "#111827" }}
                />
              </div>
            </div>

            {activeList && (
              <div style={{ marginTop: 8, background: "#ffffff", borderRadius: 8, border: "1px solid #e5e7eb" }}>
                <div style={{ display: "grid", gridTemplateColumns: "40px 2fr 1.2fr 1fr 1fr 1.2fr", padding: "0.6rem 0.8rem", color: "#111827", background: "#f3f4f6", alignItems: "center" }}>
                  <div>
                    <input
                      type="checkbox"
                      aria-label="Seleccionar todos (página lista)"
                      checked={pagedBottom.length > 0 && pagedBottom.every((c) => selectedIds.has(c.id))}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds((prev) => {
                            const next = new Set(prev);
                            pagedBottom.forEach((c) => next.add(c.id));
                            return next;
                          });
                        } else {
                          setSelectedIds((prev) => {
                            const next = new Set(prev);
                            pagedBottom.forEach((c) => next.delete(c.id));
                            return next;
                          });
                        }
                      }}
                    />
                  </div>
                  <div>Nombres y apellidos</div>
                  <div>Teléfono</div>
                  <div>Nota</div>
                  <div>Etiqueta</div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                    <span>Acciones</span>
                    <span style={{ color: "#94a3b8", fontSize: 12 }}>
                      Seleccionados en esta página: {pagedBottom.filter((c) => selectedIds.has(c.id)).length}
                    </span>
                  </div>
                </div>

                {filteredListContacts.length === 0 ? (
                  <div style={{ padding: "1rem", color: "#94a3b8", textAlign: "center" }}>Esta lista no tiene contactos.</div>
                ) : (
                  pagedBottom.map((c) => {
                    const tag = tags.find(t => t.id === c.tag);
                    const bg = tag ? `${tag.color}22` : 'transparent';
                    const hasNote = !!(c.note && String(c.note).trim());
                    const open = openNoteIds.has(c.id);
                    return (
                      <div key={c.id} style={{ display: "grid", gridTemplateColumns: "40px 2fr 1.2fr 1fr 1fr 1.2fr", padding: "0.6rem 0.8rem", borderTop: "1px solid #e5e7eb", alignItems: "center", background: bg }}>
                        <div>
                          <input
                            type="checkbox"
                            checked={selectedIds.has(c.id)}
                            onChange={(e) => {
                              setSelectedIds((prev) => {
                                const next = new Set(prev);
                                if (e.target.checked) next.add(c.id); else next.delete(c.id);
                                return next;
                              });
                            }}
                            aria-label={`Seleccionar ${c.full_name}`}
                          />
                        </div>

                        <div style={{ display: 'flex', gap: 8, flexDirection: 'column', alignItems: 'flex-start' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span>{c.full_name}</span>
                            {hasNote && (
                              <span
                                title={(c.note || '').slice(0, 120)}
                                aria-label="Tiene nota"
                                role="button"
                                tabIndex={0}
                                onClick={() => {
                                  setOpenNoteIds(prev => {
                                    const next = new Set(prev);
                                    if (next.has(c.id)) next.delete(c.id); else next.add(c.id);
                                    return next;
                                  });
                                  setNoteDrafts(d => ({ ...d, [c.id]: (c.note || '') }));
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setOpenNoteIds(prev => {
                                      const next = new Set(prev);
                                      if (next.has(c.id)) next.delete(c.id); else next.add(c.id);
                                      return next;
                                    });
                                    setNoteDrafts(d => ({ ...d, [c.id]: (c.note || '') }));
                                  }
                                }}
                                style={{ fontSize: 14, cursor: 'pointer' }}
                              >
                                📝
                              </span>
                            )}
                          </div>

                          {/* Se eliminan etiquetas y listas duplicadas de esta columna para simplificar la fila */}
                        </div>

                        <div style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace', letterSpacing: '0.02em' }}>{c.phone}</div>

                        {/* Nota */}
                        <div>
                          <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 6px', borderRadius: 6, background: 'transparent' }}>
                            <div
                              role="checkbox"
                              tabIndex={0}
                              aria-checked={open}
                              aria-label={`Nota para ${c.full_name}`}
                              onClick={() => {
                                setOpenNoteIds(prev => {
                                  const next = new Set(prev);
                                  if (next.has(c.id)) next.delete(c.id); else next.add(c.id);
                                  return next;
                                });
                                setNoteDrafts(d => ({ ...d, [c.id]: (c.note || '') }));
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  setOpenNoteIds(prev => {
                                    const next = new Set(prev);
                                    if (next.has(c.id)) next.delete(c.id); else next.add(c.id);
                                    return next;
                                  });
                                  setNoteDrafts(d => ({ ...d, [c.id]: (c.note || '') }));
                                }
                              }}
                              style={{
                                width: 18,
                                height: 18,
                                borderRadius: 4,
                                border: '1px solid #9ca3af',
                                background: hasNote ? '#16a34a' : '#ffffff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#ffffff',
                                fontSize: 12,
                                fontWeight: 700,
                                lineHeight: '18px',
                                cursor: 'pointer'
                              }}
                              title={hasNote ? 'Tiene nota' : 'Sin nota'}
                            >{hasNote ? '✓' : ''}</div>
                          </label>

                          {open && (
                            <div style={{ marginTop: 8, display: 'grid', gap: 6 }}>
                              <textarea
                                rows={3}
                                value={noteDrafts[c.id] ?? ''}
                                onChange={(e) => setNoteDrafts(d => ({ ...d, [c.id]: e.target.value }))}
                                placeholder="Escribe una nota para este contacto..."
                                style={{ width: '100%', background: '#ffffff', color: '#111827', border: '1px solid #e5e7eb', borderRadius: 8, padding: 8 }}
                              />
                              <div style={{ display: 'flex', gap: 8 }}>
                                <button type="button" onClick={async () => {
                                  if (savingNoteIds.has(c.id)) return;
                                  setSavingNoteIds(prev => { const n = new Set(prev); n.add(c.id); return n; });
                                  try {
                                    const payload = { note: (noteDrafts[c.id] ?? '').trim() };
                                    const { data } = await api.patch(`contactos/${c.id}/`, payload);
                                    setContacts(prev => prev.map(x => x.id === c.id ? data : x));
                                    if (!payload.note) {
                                      setOpenNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; });
                                    }
                                  } catch (e) { console.error(e); alert('No se pudo guardar la nota'); }
                                  finally { setSavingNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; }); }
                                }} disabled={savingNoteIds.has(c.id)} style={{ background: '#0d6efd', color: '#fff', border: 'none', borderRadius: 6, padding: '.35rem .6rem', opacity: savingNoteIds.has(c.id) ? 0.7 : 1 }}>{savingNoteIds.has(c.id) ? 'Guardando…' : 'Guardar'}</button>

                                {hasNote && (
                                  <button type="button" onClick={async () => {
                                    if (savingNoteIds.has(c.id)) return;
                                    setSavingNoteIds(prev => { const n = new Set(prev); n.add(c.id); return n; });
                                    try {
                                      const { data } = await api.patch(`contactos/${c.id}/`, { note: '' });
                                      setContacts(prev => prev.map(x => x.id === c.id ? data : x));
                                      setOpenNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; });
                                    } catch (e) { console.error(e); alert('No se pudo eliminar la nota'); }
                                    finally { setSavingNoteIds(prev => { const n = new Set(prev); n.delete(c.id); return n; }); }
                                  }} disabled={savingNoteIds.has(c.id)} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: 6, padding: '.35rem .6rem', opacity: savingNoteIds.has(c.id) ? 0.7 : 1 }}>Eliminar</button>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <TagDropdown
                              tags={tags}
                              value={c.tag ?? null}
                              onChange={async (id) => {
                                const payload = { tag: id ? Number(id) : null };
                                try {
                                  const { data } = await api.patch(`contactos/${c.id}/`, payload);
                                  setContacts(prev => prev.map(x => x.id === c.id ? data : x));
                                } catch {
                                  alert('No se pudo asignar la etiqueta.');
                                }
                              }}
                              allowNull={true}
                              variant="light"
                            />
                            <RowListsDropdown contactId={c.id} />
                          </div>
                          {(() => {
                            const member = (Array.isArray(lists) ? lists : []).filter(l => Array.isArray(l.contacts) && l.contacts.includes(c.id));
                            if (!member.length) return <span style={{ fontSize: 11, color: '#6b7280' }}>Sin listas</span>;
                            const visible = member.slice(0, 2);
                            const extra = member.length - visible.length;
                            return (
                              <div style={{ marginTop: 2, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                {visible.map(l => (
                                  <span key={l.id} title={`Ver contactos de la lista: ${l.name}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '2px 6px', borderRadius: 9999, border: '1px solid #e5e7eb', background: '#f9fafb', color: '#111827', cursor: 'pointer' }} onClick={() => { setListMembersListId(l.id); setListMembersQ(''); setShowListMembers(true); }}>
                                    <span style={{ width: 10, height: 10, borderRadius: 9999, background: l.color || '#e5e7eb', display: 'inline-block', border: '1px solid #e5e7eb' }} />
                                    {l.name}
                                  </span>
                                ))}
                                {extra > 0 && (
                                  <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 6px', borderRadius: 9999, background: '#f3f4f6', color: '#4b5563', fontSize: 11 }}>+{extra}</span>
                                )}
                              </div>
                            );
                          })()}
                        </div>

                        <div style={{ display: "flex", gap: ".5rem", alignItems: 'center' }}>
                          <button
                            type="button"
                            className="bg-gradient-to-r from-emerald-500 to-cyan-600 hover:from-emerald-600 hover:to-cyan-700 text-white rounded-md px-2 py-1 text-sm transition"
                            onClick={() => {
                              try { console.log('[Contactos] Click Editar (fila lista activa inferior)', c); } catch {}
                              const tokens = (c.full_name || "").trim().split(/\s+/);
                              let first = ""; let last = "";
                              if (tokens.length >= 2) { last = tokens.pop(); first = tokens.join(" "); }
                              else if (tokens.length === 1) { first = tokens[0]; }
                              // Detectar código de país y separar local
                              let countryCode = "+593";
                              let local = c.phone || "";
                              if (local.startsWith("+")) {
                                const codes = [...COUNTRY_CODES.map(x => x.code)].sort((a,b) => b.length - a.length);
                                const m = codes.find(code => local.startsWith(code));
                                if (m) { countryCode = m; local = local.slice(m.length); }
                                else { local = local.replace(/^\+/, ""); }
                              }
                              setEditForm({ id: c.id, first_name: first, last_name: last, phone: local, countryCode });
                              setEditError({});
                              setShowEdit(true);
                            }}
                          >Editar</button>

                          <button
                            type="button"
                            className="bg-gradient-to-r from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700 text-white rounded-md px-2 py-1 text-sm transition"
                            onClick={async () => {
                              const ok = window.confirm("Eliminar este contacto? Esta acción no se puede deshacer.");
                              if (!ok) return;
                              try {
                                await api.delete(`contactos/${c.id}/`);
                                setContacts(prev => prev.filter(x => x.id !== c.id));
                                setSelectedIds(prev => { const next = new Set(prev); next.delete(c.id); return next; });
                                // Si la lista activa contiene este contacto, refrescarla
                                if (activeListId) {
                                  try { const { data } = await api.get(`listas/${activeListId}/`); setActiveList(data); } catch {}
                                }
                              } catch (e) {
                                alert("No se pudo eliminar el contacto.");
                              }
                            }}
                          >Eliminar</button>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            )}
            <Pagination page={currentBottom} totalPages={totalPagesBottom} onPageChange={setPageBottom} />
          </div>
        </>
        )}

        {contactsViewTab === "lists" && (
          <section className="rounded-2xl border border-[#2a3b54] bg-[#0f1c30] p-5 shadow-sm">
            {activeListId && activeList ? (
              <div className="space-y-4">
                <div className="flex flex-wrap items-center gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      setActiveListId(null);
                      setActiveList(null);
                      setListDetailQ("");
                    }}
                    className="inline-flex items-center gap-2 text-base font-semibold text-[#c5d3e6] transition hover:text-white"
                  >
                    <span className="text-lg leading-none">←</span>
                    Volver a listas
                  </button>

                  <div className="inline-flex items-center gap-2 text-xl font-semibold text-gray-100">
                    <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: activeList.color || "#a78bfa" }} />
                    {activeList.name || "Lista"}
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                  <article className="rounded-2xl border border-[#2a3b54] bg-gradient-to-r from-[#1b1d33] to-[#1b2030] px-4 py-3">
                    <p className="text-[38px] font-semibold leading-none text-[#a78bfa]">{listTotalCount}</p>
                    <p className="mt-1 text-sm text-[#9cb0c8]">Total en lista</p>
                  </article>
                  <article className="rounded-2xl border border-[#1f4f4b] bg-gradient-to-r from-[#0f2e2a] to-[#12392f] px-4 py-3">
                    <p className="text-[38px] font-semibold leading-none text-[#22c55e]">{listWithWhatsappCount}</p>
                    <p className="mt-1 text-sm text-[#9cb0c8]">Con WhatsApp</p>
                  </article>
                  <article className="rounded-2xl border border-[#2a3b54] bg-gradient-to-r from-[#131b2a] to-[#101927] px-4 py-3">
                    <p className="text-[38px] font-semibold leading-none text-[#94a3b8]">{listWithoutWhatsappCount}</p>
                    <p className="mt-1 text-sm text-[#9cb0c8]">Sin WhatsApp</p>
                  </article>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  <div className="flex min-w-[260px] flex-1 items-center gap-2 rounded-xl border border-[#2f425f] bg-gradient-to-r from-[#1c2a3f] to-[#28364a] px-3 py-2.5">
                    <FaSearch className="text-xs text-[#8fa1bd]" />
                    <input
                      value={listDetailQ}
                      onChange={(e) => setListDetailQ(e.target.value)}
                      placeholder="Buscar en esta lista..."
                      className="flex-1 bg-transparent border-none outline-none text-gray-100 placeholder-gray-400"
                    />
                  </div>

                  <button
                    type="button"
                    onClick={openAddContactsModal}
                    className="inline-flex items-center gap-2 rounded-xl bg-[#a78bfa] px-4 py-2.5 text-sm font-semibold text-[#1b1138] transition hover:bg-[#9574f7]"
                  >
                    <FaUserPlus className="text-xs" />
                    Agregar contactos
                  </button>
                </div>

                <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-[#2a3b54] bg-[#121f33] px-3 py-2.5">
                  <p className="text-xs text-[#9cb0c8]">Mantén presionado un contacto para activar selección múltiple.</p>
                  <div className="flex flex-wrap items-center gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        if (listSelectionMode) {
                          setListSelectionMode(false);
                          setListSelectedIds(new Set());
                        } else {
                          setListSelectionMode(true);
                        }
                      }}
                      className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold transition ${listSelectionMode ? "border-[#5c6b7f] bg-[#2a3547] text-[#d6e1ef]" : "border-[#3c6ca8] bg-[#17355a] text-[#8ec8ff] hover:bg-[#204477]"}`}
                    >
                      {listSelectionMode ? "Cancelar selección" : "Seleccionar"}
                    </button>

                    {listSelectionMode && (
                      <>
                        <span className="text-xs font-semibold text-[#c5d3e6]">{selectedInActiveListCount} seleccionados</span>
                        <button
                          type="button"
                          onClick={removeSelectedFromActiveList}
                          disabled={selectedInActiveListCount === 0 || listSelectionBusy}
                          className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-xs font-semibold transition ${selectedInActiveListCount > 0 && !listSelectionBusy ? "border-[#7a2f3d] bg-[#4b1f2f] text-[#ff8d95] hover:bg-[#5a2436]" : "cursor-not-allowed border-[#38475c] bg-[#222f42] text-[#6e8097]"}`}
                        >
                          {listSelectionBusy ? "Quitando..." : "Quitar seleccionados"}
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div className="overflow-hidden rounded-xl border border-[#2a3b54] bg-[#111c2e]">
                  <div className={`grid ${listGridCols} items-center border-b border-[#2a3b54] bg-[#1a263a] px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[#9db0c9]`}>
                    {listSelectionMode && (
                      <label className="inline-flex items-center justify-center">
                        <input
                          type="checkbox"
                          checked={allVisibleListSelected}
                          onChange={() => {
                            setListSelectedIds((prev) => {
                              const next = new Set(prev);
                              if (allVisibleListSelected) {
                                pagedBottom.forEach((item) => next.delete(item.id));
                              } else {
                                pagedBottom.forEach((item) => next.add(item.id));
                              }
                              return next;
                            });
                          }}
                          className="h-4 w-4 rounded border-[#3d5070] bg-[#0f1a2b] accent-[#8b5cf6]"
                          aria-label="Seleccionar todos los visibles"
                        />
                      </label>
                    )}
                    <div>Contacto</div>
                    <div>Teléfono</div>
                    <div>Etiquetas</div>
                    <div className="text-right">&nbsp;</div>
                  </div>

                  {filteredListContacts.length === 0 ? (
                    <div className="px-4 py-10 text-center text-sm text-[#9cb0c8]">Esta lista no tiene contactos.</div>
                  ) : (
                    pagedBottom.map((c) => {
                      const tag = tags.find((t) => t.id === c.tag);
                      const isSelected = listSelectedIds.has(c.id);
                      const initials = String(c.full_name || "C")
                        .split(/\s+/)
                        .filter(Boolean)
                        .slice(0, 2)
                        .map((x) => x[0])
                        .join("")
                        .toUpperCase();

                      return (
                        <div
                          key={c.id}
                          className={`grid ${listGridCols} items-center border-t border-[#24344c] px-4 py-3 transition ${listSelectionMode ? "cursor-pointer" : ""} ${isSelected ? "bg-[#162840]" : ""}`}
                          onPointerDown={() => startListLongPress(c.id)}
                          onPointerUp={clearListLongPress}
                          onPointerLeave={clearListLongPress}
                          onPointerCancel={clearListLongPress}
                          onClick={() => {
                            if (!listSelectionMode) return;
                            if (listLongPressTriggeredRef.current) {
                              listLongPressTriggeredRef.current = false;
                              return;
                            }
                            setListSelectedIds((prev) => {
                              const next = new Set(prev);
                              if (next.has(c.id)) next.delete(c.id);
                              else next.add(c.id);
                              return next;
                            });
                          }}
                        >
                          {listSelectionMode && (
                            <div className="flex items-center justify-center">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => {
                                  setListSelectedIds((prev) => {
                                    const next = new Set(prev);
                                    if (next.has(c.id)) next.delete(c.id);
                                    else next.add(c.id);
                                    return next;
                                  });
                                }}
                                onClick={(e) => e.stopPropagation()}
                                className="h-4 w-4 rounded border-[#3d5070] bg-[#0f1a2b] accent-[#8b5cf6]"
                                aria-label={`Seleccionar ${c.full_name || "contacto"}`}
                              />
                            </div>
                          )}

                          <div className="flex items-center gap-3 min-w-0">
                            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-[11px] font-bold text-emerald-300">
                              {initials || "C"}
                            </span>
                            <div className="min-w-0">
                              <p className="truncate text-sm font-semibold text-gray-100">{c.full_name}</p>
                              <p className="text-xs font-medium text-emerald-400">✓ WhatsApp</p>
                            </div>
                          </div>

                          <div className="text-sm font-medium text-[#b8c7db]">{c.phone || "—"}</div>

                          <div>
                            {tag ? (
                              <span
                                className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold"
                                style={{ borderColor: `${tag.color || "#22c55e"}88`, color: tag.color || "#22c55e", backgroundColor: `${tag.color || "#22c55e"}22` }}
                              >
                                {tag.name || "Etiqueta"}
                              </span>
                            ) : (
                              <span className="text-xs text-[#7e92ac]">—</span>
                            )}
                          </div>

                          <div className="flex justify-end">
                            {!listSelectionMode && (
                              <button
                                type="button"
                                onPointerDown={(e) => e.stopPropagation()}
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  if (!activeListId) return;
                                  const listName = activeList?.name || "esta lista";
                                  const ok = window.confirm(`¿Quitar este contacto de la lista "${listName}"?\nEl contacto no se eliminará globalmente.`);
                                  if (!ok) return;
                                  try {
                                    const { data: l } = await api.get(`listas/${activeListId}/`);
                                    const nextIds = (l.contacts || []).filter((id) => id !== c.id);
                                    await api.patch(`listas/${activeListId}/`, { contacts: nextIds });
                                    await refreshLists(activeListId);
                                  } catch (e2) {
                                    alert("No se pudo quitar el contacto de la lista.");
                                  }
                                }}
                                className="inline-flex items-center rounded-md border border-[#5b2530] bg-[#3b1b28] px-3 py-1.5 text-sm font-semibold text-[#ff666d] transition hover:bg-[#4a2230]"
                              >
                                × Quitar
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>

                <Pagination page={currentBottom} totalPages={totalPagesBottom} onPageChange={setPageBottom} />
              </div>
            ) : (
              <>
                <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
                  <div>
                    <p className="text-sm font-semibold text-gray-100">
                      {lists.length} lista{lists.length !== 1 ? "s" : ""} creada{lists.length !== 1 ? "s" : ""}
                    </p>
                    <p className="text-xs text-gray-400">
                      Agrupa tus contactos para usarlos en campañas
                    </p>
                  </div>

                  <button
                    type="button"
                    onClick={() => {
                      setListCreateForm({ name: "", description: "", color: "#22c55e" });
                      setShowListCreateModal(true);
                    }}
                    className="inline-flex items-center gap-2 rounded-xl bg-[#22c55e] px-5 py-2.5 text-base font-semibold text-[#052e16] transition hover:bg-[#16a34a]"
                  >
                    <FaPlus className="text-sm" />
                    Nueva lista
                  </button>
                </div>

                {lists.length === 0 ? (
                  <div className="rounded-xl border-2 border-dashed border-[#2a3b54] px-6 py-12 text-center">
                    <p className="text-sm font-medium text-gray-200">Aún no tienes listas.</p>
                    <p className="mt-1 text-xs text-gray-400">Crea tu primera lista para segmentar campañas y contactos.</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    {(lists || []).map((list) => {
                      const count = Array.isArray(list?.contacts) ? list.contacts.length : 0;
                      const members = (contacts || []).filter((c) => Array.isArray(list?.contacts) && list.contacts.includes(c.id));
                      const desc = (list?.description || "Lista general de contactos").trim();
                      return (
                        <article
                          key={list.id}
                          onClick={() => openListFromCards(list.id)}
                          className="group relative cursor-pointer rounded-2xl border border-[#2a3b54] bg-[#111c2e] p-5 transition hover:-translate-y-0.5 hover:border-[#3f5677] hover:shadow-lg"
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              openListFromCards(list.id);
                            }
                          }}
                        >
                          <button
                            type="button"
                            aria-label={`Eliminar lista ${list.name || "Lista"}`}
                            title="Eliminar lista"
                            disabled={isListBusy}
                            onClick={async (e) => {
                              e.stopPropagation();
                              if (isListBusy) return;
                              const ok = window.confirm(`¿Eliminar la lista "${list.name || ""}"? Los contactos no se borrarán.`);
                              if (!ok) return;
                              setIsListBusy(true);
                              try {
                                await api.delete(`listas/${list.id}/`);
                                if (activeListId === list.id) {
                                  setActiveListId(null);
                                  setActiveList(null);
                                }
                                const res = await api.get("listas/");
                                setLists(Array.isArray(res.data) ? res.data : []);
                              } catch (e2) {
                                alert("No se pudo eliminar la lista.");
                              } finally {
                                setIsListBusy(false);
                              }
                            }}
                            className={`absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-md border border-[#6b1e2a] bg-[#3a1520] text-[#ff6b73] transition ${isListBusy ? "cursor-not-allowed opacity-50" : "opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 hover:bg-[#4a1a28]"}`}
                          >
                            <FaTrash className="text-xs" />
                          </button>

                          <div className="mb-4 h-[3px] rounded-full" style={{ background: list.color || "#22c55e" }} />

                          <div className="mb-3 flex items-start justify-between gap-2">
                            <div
                              className="flex items-center justify-center rounded-xl"
                              style={{ width: 42, height: 42, background: `${list.color || "#22c55e"}1f`, color: list.color || "#22c55e" }}
                            >
                              <FaListUl className="text-sm" />
                            </div>
                          </div>

                          <h3 className="truncate text-lg font-semibold leading-tight text-gray-100">{list.name || "Lista"}</h3>
                          <p className="mt-1 text-sm text-gray-400">{desc}</p>

                          <div className="mt-4 flex items-center justify-between border-t border-[#2a3b54] pt-4">
                            <div className="flex items-center gap-2">
                              <div className="flex -space-x-2">
                                {members.slice(0, 2).map((m) => {
                                  const initial = String(m.full_name || "C").trim().charAt(0).toUpperCase();
                                  return (
                                    <span
                                      key={`${list.id}-${m.id}`}
                                      className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-[#111c2e] bg-[#123f36] text-[10px] font-bold text-[#5eead4]"
                                    >
                                      {initial}
                                    </span>
                                  );
                                })}
                              </div>
                              <span className="text-[22px] font-semibold text-gray-100">{count}</span>
                              <span className="text-sm text-gray-400">contacto{count !== 1 ? "s" : ""}</span>
                            </div>

                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                openListFromCards(list.id);
                              }}
                              className="inline-flex items-center gap-1 text-sm font-semibold"
                              style={{ color: list.color || "#22c55e" }}
                            >
                              Ver
                              <span className="text-base">›</span>
                            </button>
                          </div>
                        </article>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </section>
        )}
        {showAddContactsModal && activeList ? createPortal(
          <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
            <div className="w-[min(690px,96vw)] rounded-2xl border border-[#2a3b54] bg-gradient-to-b from-[#1a2436] to-[#111a2b] p-5 shadow-2xl">
              <div className="mb-3 flex items-start justify-between gap-4">
                <div>
                  <h3 className="text-[34px] font-semibold leading-tight text-gray-100">Agregar a «{activeList.name || "Lista"}»</h3>
                  <p className="mt-1 text-sm text-[#9cb0c8]">
                    {availableContactsForActiveList.length} contacto{availableContactsForActiveList.length !== 1 ? "s" : ""} disponible{availableContactsForActiveList.length !== 1 ? "s" : ""}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setShowAddContactsModal(false);
                    setAddContactsQ("");
                    setAddContactsSelectedIds(new Set());
                    setAddContactsError("");
                  }}
                  className="text-2xl leading-none text-[#94a3b8] transition hover:text-white"
                >
                  ✕
                </button>
              </div>

              <div className="mb-3 flex min-w-[260px] flex-1 items-center gap-2 rounded-xl border border-[#2f425f] bg-gradient-to-r from-[#1c2a3f] to-[#28364a] px-3 py-2.5">
                <FaSearch className="text-xs text-[#8fa1bd]" />
                <input
                  value={addContactsQ}
                  onChange={(e) => setAddContactsQ(e.target.value)}
                  placeholder="Buscar por nombre o número..."
                  className="flex-1 bg-transparent border-none outline-none text-gray-100 placeholder-gray-400"
                />
              </div>

              <div className="mb-2 flex items-center justify-between rounded-xl border border-[#2a3b54] bg-[#141f31] px-3 py-2">
                <label className="inline-flex cursor-pointer items-center gap-2 text-sm font-medium text-[#d6e1ef]">
                  <input
                    type="checkbox"
                    checked={allVisibleAddContactsSelected}
                    onChange={() => {
                      setAddContactsSelectedIds((prev) => {
                        const next = new Set(prev);
                        if (allVisibleAddContactsSelected) {
                          filteredAvailableContactsForActiveList.forEach((c) => next.delete(c.id));
                        } else {
                          filteredAvailableContactsForActiveList.forEach((c) => next.add(c.id));
                        }
                        return next;
                      });
                    }}
                    className="h-4 w-4 rounded border-[#3d5070] bg-[#0f1a2b] accent-[#8b5cf6]"
                  />
                  Seleccionar todos
                </label>
                <span className="text-xs font-semibold uppercase tracking-wide text-[#9cb0c8]">
                  {addContactsSelectedIds.size} seleccionado{addContactsSelectedIds.size !== 1 ? "s" : ""}
                </span>
              </div>

              <div className="max-h-[320px] overflow-y-auto rounded-xl border border-[#2a3b54] bg-[#111c2e]">
                {filteredAvailableContactsForActiveList.length === 0 ? (
                  <div className="px-4 py-10 text-center text-sm text-[#9cb0c8]">
                    {availableContactsForActiveList.length === 0
                      ? "No hay más contactos para agregar a esta lista."
                      : "No se encontraron contactos con ese criterio."}
                  </div>
                ) : (
                  filteredAvailableContactsForActiveList.map((c) => {
                    const selected = addContactsSelectedIds.has(c.id);
                    const initials = String(c.full_name || "C")
                      .split(/\s+/)
                      .filter(Boolean)
                      .slice(0, 2)
                      .map((x) => x[0])
                      .join("")
                      .toUpperCase();
                    return (
                      <label
                        key={c.id}
                        className={`flex cursor-pointer items-center gap-3 border-t border-[#24344c] px-3 py-2.5 transition ${selected ? "bg-[#1d2b42]" : "hover:bg-[#16253a]"}`}
                      >
                        <input
                          type="checkbox"
                          checked={selected}
                          onChange={() => {
                            setAddContactsSelectedIds((prev) => {
                              const next = new Set(prev);
                              if (next.has(c.id)) next.delete(c.id);
                              else next.add(c.id);
                              return next;
                            });
                          }}
                          className="h-4 w-4 rounded border-[#3d5070] bg-[#0f1a2b] accent-[#8b5cf6]"
                        />

                        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-xs font-bold text-emerald-300">
                          {initials || "C"}
                        </span>

                        <span className="min-w-0 flex-1">
                          <span className="block truncate text-base font-semibold text-gray-100">{c.full_name || "Sin nombre"}</span>
                          <span className="block truncate text-sm text-[#9cb0c8]">{c.phone || "Sin número"}</span>
                        </span>

                        {String(c.phone || "").trim() ? (
                          <span className="inline-flex items-center rounded-md bg-[#123f36] px-2 py-0.5 text-xs font-semibold text-[#22c55e]">WA</span>
                        ) : null}
                      </label>
                    );
                  })
                )}
              </div>

              {addContactsError && <div className="mt-2 text-xs text-red-400">{addContactsError}</div>}

              <div className="mt-4 flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => {
                    setShowAddContactsModal(false);
                    setAddContactsQ("");
                    setAddContactsSelectedIds(new Set());
                    setAddContactsError("");
                  }}
                  className="flex-1 rounded-xl border border-[#2a3b54] bg-transparent px-4 py-2 font-semibold text-[#9fb2c9] transition hover:bg-[#18263a]"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  disabled={isAddContactsBusy || addContactsSelectedIds.size === 0}
                  onClick={submitAddContactsToList}
                  className={`flex-1 rounded-xl px-4 py-2 font-semibold transition ${
                    isAddContactsBusy || addContactsSelectedIds.size === 0
                      ? "cursor-not-allowed bg-[#2a3547] text-[#7f8ea4]"
                      : "bg-[#2563eb] text-white hover:bg-[#1d4ed8]"
                  }`}
                >
                  {isAddContactsBusy ? "Agregando..." : "Agregar a lista"}
                </button>
              </div>
            </div>
          </div>,
          document.body
        ) : null}
{/* Modal Agregar cliente */}
{showForm ? createPortal(
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/55 p-4" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
      <div className="w-[min(430px,94vw)] rounded-2xl border border-[#2a3b54] bg-gradient-to-b from-[#1a2436] to-[#111a2b] p-5 shadow-2xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-[31px] font-semibold leading-tight text-gray-100">Agregar contacto</h3>
          <button
            type="button"
            onClick={() => setShowForm(false)}
            className="text-2xl leading-none text-[#94a3b8] transition hover:text-white"
          >
            ✕
          </button>
        </div>

        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const errs = {};
            if (!form.full_name.trim()) errs.full_name = "Obligatorio";
            if (!form.phone.trim()) errs.phone = "Obligatorio";
            setFormError(errs);
            if (Object.keys(errs).length) return;

            setIsSaving(true);
            try {
              const compact = form.phone.trim().replace(/[\s()-]/g, "");
              const normalizedPhone = compact.startsWith("+") ? compact : `+${compact.replace(/^\+/, "")}`;

              if (!/^\+\d{7,15}$/.test(normalizedPhone)) {
                setFormError({ phone: "Ingresa un teléfono válido con código de país" });
                setIsSaving(false);
                return;
              }

              const payload = {
                full_name: form.full_name.trim(),
                phone: normalizedPhone,
              };
              const noteValue = (form.note || "").trim();
              if (noteValue) payload.note = noteValue;

              const { data } = await api.post("contactos/", payload);
              setContacts((prev) => [data, ...prev]);
              if (activeListFilterId) setActiveListFilterId(null);
              setShowForm(false);
              setForm({ full_name: "", phone: "", note: "" });
            } catch (e) {
              const msg = e?.response?.data;
              const nextErr = {};
              if (msg?.phone) nextErr.phone = Array.isArray(msg.phone) ? msg.phone.join(" ") : String(msg.phone);
              if (msg?.full_name) nextErr.full_name = Array.isArray(msg.full_name) ? msg.full_name.join(" ") : String(msg.full_name);
              if (msg?.note) nextErr.note = Array.isArray(msg.note) ? msg.note.join(" ") : String(msg.note);
              if (msg && !Object.keys(nextErr).length) nextErr.__all__ = typeof msg === "string" ? msg : (msg.detail || "No se pudo crear el contacto");
              setFormError(nextErr);
            } finally {
              setIsSaving(false);
            }
          }}
        >
          <div className="space-y-3.5">
            <div>
              <label className="mb-1 block text-sm font-semibold text-gray-100">Nombre completo *</label>
              <input
                placeholder="Ej. Juan Pérez"
                value={form.full_name}
                onChange={(e) => setForm((f) => ({ ...f, full_name: e.target.value }))}
                className="w-full rounded-xl border border-[#2d405b] bg-[#26344a] px-3 py-2.5 text-gray-100 placeholder-gray-400 outline-none transition focus:border-[#3e5b80]"
              />
              {formError.full_name && <div className="mt-1 text-xs text-red-400">{String(formError.full_name)}</div>}
            </div>

            <div>
              <label className="mb-1 block text-sm font-semibold text-gray-100">Teléfono (con código de país) *</label>
              <input
                placeholder="+593999000000"
                value={form.phone}
                onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
                className="w-full rounded-xl border border-[#2d405b] bg-[#26344a] px-3 py-2.5 text-gray-100 placeholder-gray-400 outline-none transition focus:border-[#3e5b80]"
              />
              {formError.phone && <div className="mt-1 text-xs text-red-400">{String(formError.phone)}</div>}
            </div>

            <div>
              <label className="mb-1 block text-sm font-semibold text-gray-100">Nota (opcional)</label>
              <input
                placeholder="Agregar una nota..."
                value={form.note}
                onChange={(e) => setForm((f) => ({ ...f, note: e.target.value }))}
                className="w-full rounded-xl border border-[#2d405b] bg-[#26344a] px-3 py-2.5 text-gray-100 placeholder-gray-400 outline-none transition focus:border-[#3e5b80]"
              />
              {formError.note && <div className="mt-1 text-xs text-red-400">{String(formError.note)}</div>}
            </div>
          </div>

          <div className="mt-5 flex items-center gap-2">
            <button
              type="button"
              onClick={() => setShowForm(false)}
              className="flex-1 rounded-xl border border-[#2a3b54] bg-transparent px-4 py-2 font-semibold text-[#9fb2c9] transition hover:bg-[#18263a]"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isSaving || !form.full_name.trim() || !form.phone.trim()}
              className={`flex-1 rounded-xl px-4 py-2 font-semibold transition ${
                isSaving || !form.full_name.trim() || !form.phone.trim()
                  ? "cursor-not-allowed bg-[#2a3547] text-[#7f8ea4]"
                  : "bg-[#2563eb] text-white hover:bg-[#1d4ed8]"
              }`}
            >
              {isSaving ? "Creando..." : "Crear contacto"}
            </button>
          </div>

          {formError.__all__ && <div className="mt-2 text-xs text-red-400">{String(formError.__all__)}</div>}
        </form>
      </div>
    </div>,
  document.body
) : null}

          {/* Modal Editar cliente */}
          {showEdit ? createPortal(
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[2000]" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
              <div className="w-[min(980px,96vw)] bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-700 rounded-xl p-5">

                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Editar cliente</h3>
                  <button onClick={() => setShowEdit(false)} className="text-gray-400 dark:text-gray-300 text-xl hover:text-gray-600 dark:hover:text-gray-100 transition">✕</button>
                </div>

                <div className="text-gray-400 mb-3">Actualiza la información del contacto</div>

                <form onSubmit={async (e) => {
                  e.preventDefault();
                  const errs = {};
                  if (!editForm.first_name?.trim()) errs.first_name = 'Obligatorio';
                  if (!editForm.last_name?.trim()) errs.last_name = 'Obligatorio';
                  if (!editForm.phone?.trim()) errs.phone = 'Obligatorio';
                  setEditError(errs);
                  if (Object.keys(errs).length) return;
                  setIsEditSaving(true);
                  try {
                    const rawLocal = (editForm.phone || '').trim().replace(/[\s-]/g, '');
                    const localNoZeros = rawLocal.replace(/^0+/, '');
                    const cc = (editForm.countryCode || '').startsWith('+') ? editForm.countryCode : `+${editForm.countryCode}`;
                    if (!localNoZeros) { setEditError({ phone: 'Ingresa un teléfono válido' }); setIsEditSaving(false); return; }
                    const fullPhone = `${cc}${localNoZeros}`;
                    const payload = { full_name: `${editForm.first_name.trim()} ${editForm.last_name.trim()}`.trim(), phone: fullPhone };
                    const { data } = await api.patch(`contactos/${editForm.id}/`, payload);
                    setContacts(prev => prev.map(x => x.id === data.id ? data : x));
                    setShowEdit(false);
                  } catch (e) {
                    const msg = e?.response?.data;
                    const nextErr = {};
                    if (msg?.phone) nextErr.phone = Array.isArray(msg.phone) ? msg.phone.join(' ') : String(msg.phone);
                    if (msg?.full_name) nextErr.first_name = Array.isArray(msg.full_name) ? msg.full_name.join(' ') : String(msg.full_name);
                    if (!Object.keys(nextErr).length && msg) nextErr.__all__ = typeof msg === 'string' ? msg : (msg.detail || 'No se pudo actualizar el contacto');
                    setEditError(nextErr);
                  } finally {
                    setIsEditSaving(false);
                  }
                }}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <input
                      placeholder="Nombres"
                      value={editForm.first_name}
                      onChange={(e) => setEditForm((f) => ({ ...f, first_name: e.target.value }))}
                      className="px-3 py-2 rounded-lg border border-gray-700 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {editError.first_name && <div className="md:col-span-1 text-sm text-red-500">{String(editError.first_name)}</div>}
                    <input
                      placeholder="Apellidos"
                      value={editForm.last_name}
                      onChange={(e) => setEditForm((f) => ({ ...f, last_name: e.target.value }))}
                      className="px-3 py-2 rounded-lg border border-gray-700 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {editError.last_name && <div className="md:col-span-1 text-sm text-red-500">{String(editError.last_name)}</div>}

                    <div className="flex gap-2 col-span-1 md:col-span-2">
                      <select
                        value={editForm.countryCode}
                        onChange={(e) => setEditForm((f) => ({ ...f, countryCode: e.target.value }))}
                        className="px-3 py-2 rounded-lg border border-gray-700 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        {COUNTRY_CODES.map(c => (
                          <option key={c.code} value={c.code}>{c.code} {c.label}</option>
                        ))}
                      </select>
                      <input
                        placeholder="Teléfono"
                        value={editForm.phone}
                        onChange={(e) => setEditForm((f) => ({ ...f, phone: e.target.value }))}
                        className="flex-1 px-3 py-2 rounded-lg border border-gray-700 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                    {editError.phone && <div className="md:col-span-2 text-sm text-red-500">{String(editError.phone)}</div>}
                  </div>

                  <div className="flex justify-end gap-2 mt-4">
                    <button type="button" onClick={() => setShowEdit(false)} className="bg-gray-800 dark:bg-slate-700 text-white border border-gray-700 dark:border-slate-700 rounded-lg px-4 py-1 hover:bg-gray-700 dark:hover:bg-slate-600 transition">Cancelar</button>
                    <button type="submit" disabled={isEditSaving} className={`rounded-lg px-4 py-1 font-semibold text-white ${isEditSaving ? 'bg-blue-700 opacity-70 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} transition`}>
                      {isEditSaving ? 'Guardando…' : 'Guardar'}
                    </button>
                  </div>
                  {editError.__all__ && <div className="text-red-500 mt-2">{String(editError.__all__)}</div>}
                </form>
              </div>
            </div>,
            document.body
          ) : null}

          
          {/* Modal Guardar/Mover en lista */}
          {showListModal ? createPortal(
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[2000]" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
              <div className="w-[min(620px,96vw)] bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-700 rounded-xl p-5">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{listModalMove ? 'Mover contactos a otra lista' : 'Guardar contactos en lista'}</h3>
                  <button onClick={() => { setShowListModal(false); setTagActionMode(null); setTagActionTagId(null); }} className="text-gray-400 dark:text-gray-300 text-xl hover:text-gray-600 dark:hover:text-gray-100 transition">✕</button>
                </div>
                <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-1">
                  <div className="text-sm text-gray-600 dark:text-gray-300">Seleccionados: {selectedIds.size}</div>
                  {selectedIds.size === 0 && <div className="text-red-500 text-sm">No hay contactos seleccionados.</div>}
                  <div className="border border-gray-200 dark:border-slate-700 rounded-lg p-3">
                    <div className="font-medium mb-2 text-gray-800 dark:text-gray-200">Listas existentes</div>
                    <div className="grid gap-2">
                      {lists.length === 0 && <div className="text-sm text-gray-500">No tienes listas todavía.</div>}
                      {lists.map(l => (
                        <label key={l.id} className="flex items-center gap-2 text-sm cursor-pointer">
                          <input
                            type="radio"
                            name="listChoice"
                            value={l.id}
                            checked={String(listForm.listId) === String(l.id)}
                            onChange={() => setListForm(f => ({ ...f, listId: l.id, mode: 'existing' }))}
                          />
                          <span className="inline-flex items-center gap-2">
                            <span className="w-3 h-3 rounded-full border border-gray-300 dark:border-slate-600" style={{ background: l.color }} />
                            <span className="text-gray-700 dark:text-gray-300">{l.name}</span>
                            <span className="text-xs text-gray-400 dark:text-gray-500">({(l.contacts || []).length} contacto(s))</span>
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="border border-gray-200 dark:border-slate-700 rounded-lg p-3">
                    <div className="font-medium mb-2 text-gray-800 dark:text-gray-200">Crear nueva lista</div>
                    <label className="flex items-center gap-2 text-sm mb-2">
                      <input
                        type="radio"
                        name="listChoice"
                        value="__new__"
                        checked={listForm.mode === 'new'}
                        onChange={() => setListForm(f => ({ ...f, mode: 'new', listId: null }))}
                      />
                      <span>Crear nueva</span>
                    </label>
                    {listForm.mode === 'new' && (
                      <div className="grid gap-3 md:grid-cols-2">
                        <div className="md:col-span-1">
                          <label className="block text-xs mb-1 text-gray-600 dark:text-gray-300">Nombre</label>
                          <input
                            value={listForm.name}
                            onChange={(e) => setListForm(f => ({ ...f, name: e.target.value }))}
                            placeholder="Ej. Clientes Octubre"
                            className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>
                        <div className="md:col-span-1">
                          <label className="block text-xs mb-1 text-gray-600 dark:text-gray-300">Color</label>
                          <input
                            type="color"
                            value={listForm.color}
                            onChange={(e) => setListForm(f => ({ ...f, color: e.target.value }))}
                            className="w-12 h-10 border-none bg-transparent"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {listModalMove && activeListId && <div className="text-xs text-amber-600 dark:text-amber-400">Los contactos se quitarán de la lista actual después de agregarlos a la nueva lista.</div>}
                  {tagActionMode && <div className="text-xs text-blue-600 dark:text-blue-400">Origen: acción masiva por etiqueta.</div>}
                </div>
                <div className="flex justify-end gap-2 mt-5">
                  <button onClick={() => { setShowListModal(false); setTagActionMode(null); setTagActionTagId(null); }} className="bg-gray-200 dark:bg-slate-700 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-lg px-4 py-1 hover:bg-gray-300 dark:hover:bg-slate-600 transition">Cancelar</button>
                  <button
                    disabled={selectedIds.size === 0 || isListBusy}
                    onClick={async () => {
                      if (selectedIds.size === 0) return;
                      setIsListBusy(true);
                      try {
                        if (listForm.mode === 'new') {
                          const name = (listForm.name || '').trim();
                          if (!name) { alert('Ingresa un nombre para la lista'); setIsListBusy(false); return; }
                          const body = { name, color: listForm.color || '#60a5fa', contacts: Array.from(selectedIds) };
                          const { data: newList } = await api.post('listas/', body);
                          const resAll = await api.get('listas/');
                          setLists(resAll.data || []);
                          setActiveListId(newList.id);
                          setActiveList(newList);
                        } else if (listForm.mode === 'existing' && listForm.listId) {
                          const listId = listForm.listId;
                          // Obtener lista destino
                          const { data: dest } = await api.get(`listas/${listId}/`);
                          const union = Array.from(new Set([...(dest.contacts || []), ...Array.from(selectedIds)]));
                          await api.patch(`listas/${listId}/`, { contacts: union });
                          // Si es movimiento: quitar de lista activa origen
                          if (listModalMove && activeListId && activeListId !== listId) {
                            try {
                              const { data: act } = await api.get(`listas/${activeListId}/`);
                              const filteredIds = (act.contacts || []).filter(cid => !selectedIds.has(cid));
                              await api.patch(`listas/${activeListId}/`, { contacts: filteredIds });
                            } catch {}
                          }
                          const resAll = await api.get('listas/');
                          setLists(resAll.data || []);
                          if (listModalMove) {
                            setActiveListId(listId);
                            try { const { data } = await api.get(`listas/${listId}/`); setActiveList(data); } catch {}
                          }
                        }
                        setShowListModal(false);
                        setSelectedIds(new Set());
                        setTagActionMode(null); setTagActionTagId(null);
                      } catch (e) {
                        alert('No se pudo actualizar la lista');
                      } finally {
                        setIsListBusy(false);
                      }
                    }}
                    className={`rounded-lg px-4 py-1 font-semibold text-white ${(selectedIds.size === 0 || isListBusy) ? 'bg-blue-700 opacity-60 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} transition`}
                  >{isListBusy ? 'Procesando…' : (listModalMove ? 'Mover' : 'Guardar')}</button>
                </div>
              </div>
            </div>,
            document.body
          ) : null}

          {/* Modal Editar lista */}
          {showListEditModal ? createPortal(
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[2000]" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
              <div className="w-[min(560px,96vw)] bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-700 rounded-xl p-5">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Editar lista</h3>
                  <button onClick={() => { setShowListEditModal(false); setListEditError(""); }} className="text-gray-400 dark:text-gray-300 text-xl hover:text-gray-600 dark:hover:text-gray-100 transition">✕</button>
                </div>
                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Nombre</label>
                    <input
                      value={listEditForm.name}
                      onChange={(e) => setListEditForm((f) => ({ ...f, name: e.target.value }))}
                      className="px-3 py-2 rounded-lg border border-gray-300 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Color</label>
                    <div className="flex items-center gap-3">
                      <input type="color" value={listEditForm.color} onChange={(e) => setListEditForm((f) => ({ ...f, color: e.target.value }))} className="w-12 h-9 border-none bg-transparent" />
                      <span className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs" style={{ borderColor: listEditForm.color, color: listEditForm.color, backgroundColor: `${listEditForm.color}20` }}>
                        <span className="w-2.5 h-2.5 rounded-full border border-gray-200 dark:border-gray-600" style={{ backgroundColor: listEditForm.color }} />
                        Vista previa
                      </span>
                    </div>
                  </div>
                  {listEditError && <div className="text-sm text-red-500">{listEditError}</div>}
                </div>
                <div className="flex justify-end gap-2 mt-5">
                  <button onClick={() => { setShowListEditModal(false); setListEditError(""); }} className="bg-gray-200 dark:bg-slate-700 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-lg px-4 py-1 hover:bg-gray-300 dark:hover:bg-slate-600 transition">Cancelar</button>
                  <button
                    disabled={isListBusy}
                    onClick={async () => {
                      if (!editingListId) { setListEditError("No hay lista seleccionada"); return; }
                      const payload = { name: (listEditForm.name || '').trim(), color: listEditForm.color };
                      if (!payload.name) { setListEditError("El nombre es obligatorio"); return; }
                      setIsListBusy(true); setListEditError("");
                      try {
                        await api.patch(`listas/${editingListId}/`, payload);
                        await refreshLists(activeListId === editingListId ? editingListId : null);
                        setShowListEditModal(false);
                      } catch (e) {
                        const msg = e?.response?.data;
                        setListEditError(typeof msg === 'string' ? msg : (msg?.name || msg?.detail || 'No se pudo actualizar la lista'));
                      } finally {
                        setIsListBusy(false);
                      }
                    }}
                    className={`rounded-lg px-4 py-1 font-semibold text-white ${isListBusy ? 'bg-blue-700 opacity-70 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} transition`}
                  >
                    {isListBusy ? 'Guardando…' : 'Guardar'}
                  </button>
                </div>
              </div>
            </div>,
            document.body
          ) : null}

          {/* Modal Crear lista */}
          {showListCreateModal ? createPortal(
            <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/55 p-4" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
              <div className="w-[min(470px,94vw)] rounded-2xl border border-[#2a3b54] bg-gradient-to-b from-[#1a2436] to-[#111a2b] p-5 shadow-2xl">
                <div className="mb-4 flex items-center justify-between">
                  <h3 className="text-[31px] font-semibold leading-tight text-gray-100">Nueva lista</h3>
                  <button type="button" onClick={() => { setShowListCreateModal(false); setListCreateError(""); }} className="text-2xl leading-none text-[#94a3b8] transition hover:text-white">✕</button>
                </div>

                <div className="mb-4 rounded-xl border border-[#1f6b4b] bg-[#15352f] p-4">
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-xl" style={{ backgroundColor: `${listCreateForm.color}1f`, color: listCreateForm.color }}>
                      <FaListUl className="text-sm" />
                    </div>
                    <div>
                      <p className="text-lg font-semibold text-gray-100">{(listCreateForm.name || "Nombre de la lista").trim() || "Nombre de la lista"}</p>
                      <p className="text-sm text-[#a9bfda]">{(listCreateForm.description || "Sin descripción").trim() || "Sin descripción"}</p>
                    </div>
                  </div>
                </div>

                <div className="space-y-3.5">
                  <div>
                    <label className="mb-1 block text-sm font-semibold text-gray-100">NOMBRE *</label>
                    <input
                      value={listCreateForm.name}
                      onChange={(e) => setListCreateForm((f) => ({ ...f, name: e.target.value }))}
                      placeholder="Ej. Clientes Premium"
                      className="w-full rounded-xl border border-[#2d405b] bg-[#26344a] px-3 py-2.5 text-gray-100 placeholder-gray-400 outline-none transition focus:border-[#3e5b80]"
                    />
                  </div>

                  <div>
                    <label className="mb-1 block text-sm font-semibold text-gray-100">DESCRIPCIÓN (OPCIONAL)</label>
                    <input
                      value={listCreateForm.description}
                      onChange={(e) => setListCreateForm((f) => ({ ...f, description: e.target.value }))}
                      placeholder="¿Para qué es esta lista?"
                      className="w-full rounded-xl border border-[#2d405b] bg-[#26344a] px-3 py-2.5 text-gray-100 placeholder-gray-400 outline-none transition focus:border-[#3e5b80]"
                    />
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-semibold text-gray-100">COLOR DE IDENTIFICACIÓN</label>
                    <div className="flex flex-wrap items-center gap-2">
                      {LIST_COLOR_PRESETS.map((color) => {
                        const selected = color === listCreateForm.color;
                        return (
                          <button
                            key={color}
                            type="button"
                            onClick={() => setListCreateForm((f) => ({ ...f, color }))}
                            className={`relative inline-flex h-8 w-8 items-center justify-center rounded-full border border-black/25 transition ${selected ? "ring-2 ring-[#22c55e] ring-offset-2 ring-offset-[#111a2b]" : ""}`}
                            style={{ backgroundColor: color }}
                            aria-label={`Seleccionar color ${color}`}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>

                {listCreateError && <div className="mt-2 text-xs text-red-400">{listCreateError}</div>}

                <div className="mt-5 flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => { setShowListCreateModal(false); setListCreateError(""); }}
                    className="flex-1 rounded-xl border border-[#2a3b54] bg-transparent px-4 py-2 font-semibold text-[#9fb2c9] transition hover:bg-[#18263a]"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    disabled={isListBusy || !(listCreateForm.name || "").trim()}
                    onClick={async () => {
                      const name = (listCreateForm.name || '').trim();
                      if (!name) { setListCreateError('El nombre es obligatorio'); return; }
                      setIsListBusy(true);
                      setListCreateError("");
                      try {
                        const payload = { name, color: listCreateForm.color || '#22c55e' };
                        const contactsPayload = Array.from(selectedIds || []);
                        const body = contactsPayload.length ? { ...payload, contacts: contactsPayload } : payload;
                        const { data: newList } = await api.post('listas/', body);
                        await refreshLists(newList?.id || null);
                        if (newList?.id) setActiveListId(newList.id);
                        setShowListCreateModal(false);
                        setListCreateForm({ name: '', description: '', color: '#22c55e' });
                      } catch (e) {
                        const msg = e?.response?.data;
                        setListCreateError(typeof msg === 'string' ? msg : (msg?.name || msg?.detail || 'No se pudo crear la lista'));
                      } finally {
                        setIsListBusy(false);
                      }
                    }}
                    className={`flex-1 rounded-xl px-4 py-2 font-semibold transition ${
                      isListBusy || !(listCreateForm.name || "").trim()
                        ? 'cursor-not-allowed bg-[#2a3547] text-[#7f8ea4]'
                        : 'bg-[#2563eb] text-white hover:bg-[#1d4ed8]'
                    }`}
                  >
                    {isListBusy ? 'Creando...' : 'Crear lista'}
                  </button>
                </div>
              </div>
            </div>,
            document.body
          ) : null}

          {/* Modal Ver contactos de una lista (temporalmente deshabilitado) */}
          {false && showListMembers && <div />}

          {/* Modal Importar contactos (completo) */}
          {showImport ? createPortal(
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[2000]" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
              <div className="w-[min(720px,96vw)] bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-700 rounded-xl p-5">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Importar contactos</h3>
                  <button onClick={() => setShowImport(false)} className="text-gray-400 dark:text-gray-300 text-xl hover:text-gray-600 dark:hover:text-gray-100 transition">✕</button>
                </div>

                <div className="text-gray-600 dark:text-gray-300 text-sm mb-3">
                  Sube un Excel (.xlsx) con columnas <b>nombre completo</b> y <b>número</b> (numero de whatsapp con: "+" y sin el"0" despues de codigo del pais). Puedes descargar la plantilla. Ejemplo: <code>+593998552333</code>.
                </div>

                <div className="flex flex-wrap items-center gap-2 mb-4">
                  <a href={`${API_BASE}contactos/import-template/`} target="_blank" rel="noreferrer" className="bg-sky-600 hover:bg-sky-700 text-white rounded-md px-3 py-1 text-sm">Descargar plantilla</a>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="col-span-1 md:col-span-2">
                    <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Archivo (.xlsx o .csv)</label>
                    <input
                      type="file"
                      accept=".xlsx, .csv"
                      onChange={(e) => {
                        const f = e.target.files?.[0] || null;
                        setImportState((s) => ({ ...s, file: f }));
                        setImportError("");
                      }}
                      className="block w-full text-sm text-gray-900 dark:text-gray-100 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-gray-100 dark:file:bg-slate-800 file:text-gray-700 dark:file:text-gray-100 hover:file:bg-gray-200 dark:hover:file:bg-slate-700"
                    />
                    {importError && <div className="mt-1 text-sm text-red-500">{importError}</div>}
                  </div>

                  {/* Campo de código de país eliminado: ahora los números deben venir completos con +CC directamente en el Excel */}

                  <div>
                    <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Crear lista con importados</label>
                    <div className="flex items-center gap-2">
                      <input
                        id="chk-create-list"
                        type="checkbox"
                        checked={importState.creatingList}
                        onChange={(e) => setImportState((s) => ({ ...s, creatingList: e.target.checked }))}
                      />
                      <label htmlFor="chk-create-list" className="text-gray-700 dark:text-gray-300 text-sm">Crear nueva lista y agregar los importados</label>
                    </div>
                  </div>

                  {importState.creatingList && (
                    <>
                      <div>
                        <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Nombre de la lista</label>
                        <input
                          value={importState.listName}
                          onChange={(e) => setImportState((s) => ({ ...s, listName: e.target.value }))}
                          placeholder="p. ej., Clientes noviembre"
                          className="px-3 py-2 rounded-lg border border-gray-300 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                        />
                      </div>
                      <div>
                        <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Color de la lista</label>
                        <div className="flex items-center gap-3">
                          <input
                            type="color"
                            value={importState.listColor}
                            onChange={(e) => setImportState((s) => ({ ...s, listColor: e.target.value }))}
                            className="w-12 h-9 border-none bg-transparent"
                          />
                          <span
                            className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs"
                            style={{ borderColor: importState.listColor, color: importState.listColor, backgroundColor: `${importState.listColor}20` }}
                          >
                            <span className="w-2.5 h-2.5 rounded-full border border-gray-200 dark:border-gray-600" style={{ backgroundColor: importState.listColor }} />
                            Vista previa
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="flex justify-end gap-2 mt-5">
                  <button onClick={() => setShowImport(false)} disabled={importBusy} className="bg-gray-200 dark:bg-slate-700 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-lg px-4 py-1 hover:bg-gray-300 dark:hover:bg-slate-600 transition">Cancelar</button>
                  <button
                    disabled={importBusy}
                    onClick={async () => {
                      setImportError("");
                      if (!importState.file) { setImportError("Selecciona un archivo .xlsx o .csv"); return; }
                      try {
                        setImportBusy(true);
                        const file = importState.file;
                        let fileToSend = file;
                        const nameLower = (file.name || '').toLowerCase();
                        if (nameLower.endsWith('.csv')) {
                          const text = await file.text();
                          const wb = XLSX.read(text, { type: 'string' });
                          const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                          fileToSend = new File([out], 'import_convert.xlsx', { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        }
                        const buildFormData = ({ dryRun = false, allowDuplicates = false } = {}) => {
                          const fd = new FormData();
                          fd.append('file', fileToSend);
                          fd.append('create_list', importState.creatingList ? 'true' : 'false');
                          fd.append('dry_run', dryRun ? 'true' : 'false');
                          fd.append('allow_duplicates', allowDuplicates ? 'true' : 'false');
                          if (importState.creatingList) {
                            fd.append('list_name', importState.listName || 'Importados');
                            fd.append('list_color', importState.listColor || '#60a5fa');
                          }
                          return fd;
                        };

                        const { data: preview } = await api.post('contactos/import/', buildFormData({ dryRun: true }), { headers: { 'Content-Type': 'multipart/form-data' } });
                        const duplicateRows = Number(preview?.duplicate_rows || 0);
                        let allowDuplicates = false;
                        if (duplicateRows > 0) {
                          allowDuplicates = window.confirm(
                            `Se detectaron ${duplicateRows} contacto(s) duplicados y ${Number(preview?.created || 0)} nuevo(s).\n\nAceptar: importar tambien los duplicados.\nCancelar: importar solo los no duplicados.`
                          );
                        }

                        const { data } = await api.post('contactos/import/', buildFormData({ allowDuplicates }), { headers: { 'Content-Type': 'multipart/form-data' } });
                        try {
                          const res = await api.get('contactos/');
                          setContacts(Array.isArray(res.data) ? res.data : []);
                        } catch {}
                        if (data?.list_id) {
                          await refreshLists(data.list_id);
                          setActiveListId(data.list_id);
                        } else {
                          setActiveListFilterId(null);
                        }
                        setShowImport(false);
                        setImportState({ file: null, creatingList: false, listName: '', countryCode: importState.countryCode });
                        alert(
                          `Importacion completada.\nNuevos: ${Number(data?.created || 0)}\nDuplicados importados: ${Number(data?.imported_duplicates || 0)}\nDuplicados omitidos: ${allowDuplicates ? 0 : Number(data?.duplicate_rows || 0)}\nFilas omitidas por error: ${Number(data?.skipped || 0)}`
                        );
                      } catch (e) {
                        const msg = e?.response?.data;
                        const detail = typeof msg === 'string' ? msg : (msg?.detail || 'Fallo al importar.');
                        setImportError(detail);
                      } finally {
                        setImportBusy(false);
                      }
                    }}
                    className={`rounded-lg px-4 py-1 font-semibold text-white ${importBusy ? 'bg-blue-700 opacity-70 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} transition`}
                  >
                    {importBusy ? 'Importando…' : 'Importar'}
                  </button>
                </div>
              </div>
            </div>,
            document.body
          ) : null}

          {/* Modal Etiquetas (crear/editar) */}
          {showTagModal ? createPortal(
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[2000]" role="dialog" aria-modal="true" style={{ zIndex: 2147483647 }}>
              <div className="w-[min(520px,96vw)] bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-700 rounded-xl p-5">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{tagForm.id ? 'Editar etiqueta' : 'Crear etiqueta'}</h3>
                  <button onClick={() => { setShowTagModal(false); setTagError(''); }} className="text-gray-400 dark:text-gray-300 text-xl hover:text-gray-600 dark:hover:text-gray-100 transition">✕</button>
                </div>

                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Nombre</label>
                    <input
                      value={tagForm.name}
                      onChange={(e) => setTagForm((f) => ({ ...f, name: e.target.value }))}
                      className="px-3 py-2 rounded-lg border border-gray-300 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm mb-1 text-gray-700 dark:text-gray-200">Color</label>
                    <div className="flex items-center gap-3">
                      <input type="color" value={tagForm.color} onChange={(e) => setTagForm((f) => ({ ...f, color: e.target.value }))} className="w-12 h-9 border-none bg-transparent" />
                      <span className="inline-flex items-center gap-2 px-2 py-0.5 border rounded-full text-xs" style={{ borderColor: tagForm.color, color: tagForm.color, backgroundColor: `${tagForm.color}20` }}>
                        <span className="w-2.5 h-2.5 rounded-full border border-gray-200 dark:border-gray-600" style={{ backgroundColor: tagForm.color }} />
                        Vista previa
                      </span>
                    </div>
                  </div>
                  {tagError && <div className="text-sm text-red-500">{tagError}</div>}
                </div>

                <div className="flex justify-end gap-2 mt-5">
                  <button onClick={() => { setShowTagModal(false); setTagError(''); }} className="bg-gray-200 dark:bg-slate-700 text-gray-800 dark:text-gray-100 border border-gray-300 dark:border-slate-700 rounded-lg px-4 py-1 hover:bg-gray-300 dark:hover:bg-slate-600 transition">Cancelar</button>
                  <button
                    disabled={isTagBusy}
                    onClick={async () => {
                      const name = (tagForm.name || '').trim();
                      const color = (tagForm.color || '').trim();
                      if (!name) { setTagError('El nombre es obligatorio'); return; }
                      setIsTagBusy(true); setTagError('');
                      try {
                        if (tagForm.id) {
                          await api.patch(`tags/${tagForm.id}/`, { name, color });
                        } else {
                          const { data: newTag } = await api.post('tags/', { name, color });
                          // Seleccionar la etiqueta recién creada
                          if (newTag?.id) setActiveTagId(String(newTag.id));
                        }
                        // Refrescar etiquetas y contactos para ver cambios
                        try {
                          const resTags = await api.get('tags/');
                          setTags(Array.isArray(resTags.data) ? resTags.data : []);
                        } catch {}
                        setShowTagModal(false);
                      } catch (e) {
                        const msg = e?.response?.data;
                        setTagError(typeof msg === 'string' ? msg : (msg?.name || msg?.color || msg?.detail || 'No se pudo guardar la etiqueta'));
                      } finally {
                        setIsTagBusy(false);
                      }
                    }}
                    className={`rounded-lg px-4 py-1 font-semibold text-white ${isTagBusy ? 'bg-blue-700 opacity-70 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} transition`}
                  >
                    {isTagBusy ? 'Guardando…' : (tagForm.id ? 'Guardar' : 'Crear')}
                  </button>
                </div>
              </div>
            </div>,
            document.body
          ) : null}
      </main>
    </div>
  );
}

export default Contactos;
